// src/components/Clientes.jsx
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { 
  FiSearch, FiPlus, FiEdit2, FiTrash2, FiEye,
  FiUser, FiPhone, FiCalendar,
  FiFileText, FiCheckCircle, FiCheckSquare, FiClock, FiDollarSign,
  FiMessageCircle, FiFolder, FiDownload, FiX,
  FiSave, FiRefreshCw, FiBriefcase,
  FiAlertCircle, FiInfo, FiCheck, FiSend,
  FiArrowUp, FiArrowDown, FiUpload, FiLink,
  FiChevronRight, FiGrid, FiList, FiColumns, FiActivity, FiAlertTriangle,
  FiUsers, FiCreditCard, FiFolderMinus, FiFolderPlus, FiShield
} from 'react-icons/fi';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './Clientes.css';
import './ClientesWorkspace.css';
import AgregarCaso from './AgregarCaso';
import { usuarioService } from '../services/usuarioService';
import { caseTypeLabel, sectionForCaseType } from '../constants/caseTypes';
import { formatDateUS } from '../utils/dateFormat';
import USDateInput, { usDateToISO } from './USDateInput';
import { useAuth } from '../context/AuthContext';
import { isPersonalInjuryRole } from '../accessPolicy';

const API = window.__CRM_API__ || 'http://localhost:8000/api';

const Clientes = ({ onCaseCreated, initialClientId, onProfileClosed }) => {
  const { usuario } = useAuth();
  const personalInjury = isPersonalInjuryRole(usuario?.rol);
  // ============ CONFIGURACIÓN DE USUARIOS ============
  const [usuarios, setUsuarios] = useState([]);

  // ============ ESTADOS PRINCIPALES ============
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('todos');
  const [quickFilter, setQuickFilter] = useState('todos');
  const [viewMode, setViewMode] = useState('cards');
  const [visibleColumns, setVisibleColumns] = useState({ area: true, caso: true, estado: true, attorney: true, cita: true, actividad: true, salud: true });
  const [sortBy] = useState('nombre');
  const [sortOrder, setSortOrder] = useState('asc');
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [showPerfil, setShowPerfil] = useState(false);
  const [showAgregarCaso, setShowAgregarCaso] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  // La cartera se visualiza en una página completa de 3 × 5 expedientes.
  const [itemsPerPage] = useState(15);
  const [activeTab, setActiveTab] = useState('informacion');
  const [isEditing, setIsEditing] = useState(false);
  const [driveDocuments, setDriveDocuments] = useState([]);
  const [driveDocumentsError, setDriveDocumentsError] = useState('');
  const [drivePath, setDrivePath] = useState([]);
  const [newDriveFolderName, setNewDriveFolderName] = useState('');
  const [creatingDriveFolder, setCreatingDriveFolder] = useState(false);
  const [documentFile, setDocumentFile] = useState(null);
  const [previewDocument, setPreviewDocument] = useState(null);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState('');
  const [previewDocumentLoading, setPreviewDocumentLoading] = useState(false);
  const [aiSummary, setAiSummary] = useState('');
  const [aiSummaryError, setAiSummaryError] = useState('');
  const [aiSummaryLoading, setAiSummaryLoading] = useState(false);
  const [aiSummaryDrive, setAiSummaryDrive] = useState(null);
  const [eoirNationalities, setEoirNationalities] = useState([]);
  const [portalUrl, setPortalUrl] = useState('');
  const [portalBusy, setPortalBusy] = useState(false);

  // ============ ESTADOS PARA FORMULARIOS ============
  const [showNuevaTarea, setShowNuevaTarea] = useState(false);
  const [showNuevaComunicacion, setShowNuevaComunicacion] = useState(false);
  const [showNuevoPago, setShowNuevoPago] = useState(false);
  const [showNuevoDocumento, setShowNuevoDocumento] = useState(false);
  const [showEditarHonorarios, setShowEditarHonorarios] = useState(false);
  const [showEditarPago, setShowEditarPago] = useState(false);
  const [showNuevoEvento, setShowNuevoEvento] = useState(false);
  const [showAgregarExpediente, setShowAgregarExpediente] = useState(false);
  const [nuevoTipoExpediente, setNuevoTipoExpediente] = useState(personalInjury ? 'accidente_transito' : 'visa_u');
  const [nuevoDocumentoLista, setNuevoDocumentoLista] = useState('');

  // ============ ESTADO PARA NUEVA TAREA ============
  const [nuevaTarea, setNuevaTarea] = useState({
    titulo: '',
    descripcion: '',
    fecha: new Date().toISOString().split('T')[0],
    asignado_a: ''
  });
  const [taskSaving, setTaskSaving] = useState(false);
  const taskRequestInFlight = useRef(false);
  const profileRequest = useRef(0);

  // ============ ESTADO PARA NUEVA COMUNICACIÓN ============
  const [nuevaComunicacion, setNuevaComunicacion] = useState({
    tipo: 'llamada',
    fecha: new Date().toISOString().split('T')[0],
    hora: new Date().toTimeString().slice(0, 5),
    realizada_por: '',
    mensaje: ''
  });

  // ============ ESTADO PARA NUEVO PAGO ============
  const [nuevoPago, setNuevoPago] = useState({
    monto: '',
    fecha: new Date().toISOString().split('T')[0],
    concepto: '',
    metodo: 'zelle'
  });

  // ============ ESTADO PARA EDITAR PAGO ============
  const [editandoPago, setEditandoPago] = useState(null);

  // ============ ESTADO PARA EDITAR HONORARIOS ============
  const [editarHonorarios, setEditarHonorarios] = useState({
    honorarios_total: 0
  });

  // ============ ESTADO PARA NUEVO DOCUMENTO ============
  const [nuevoDocumento, setNuevoDocumento] = useState({
    nombre: '',
    tipo: 'identificacion',
    fecha: new Date().toISOString().split('T')[0]
  });

  // ============ ESTADO PARA NUEVO EVENTO ============
  const [nuevoEvento, setNuevoEvento] = useState({
    titulo: '',
    fecha: new Date().toISOString().split('T')[0],
    tipo: 'reunion'
  });

  // ============ ESTADO PARA EDICIÓN DEL CLIENTE ============
  const [editCliente, setEditCliente] = useState({
    id: null,
    nombre: '',
    apellido: '',
    fecha_nacimiento: '',
    direccion: '',
    ciudad: '',
    estado: 'FL',
    pais: 'Estados Unidos',
    telefono: '',
    email: '',
    estado_activo: 'activo',
    monitoreo: 'sin_incidencia',
    abogado_responsable: '',
    a_number: '',
    nacionalidad: '',
    numero_caso: '',
    tipo_caso: personalInjury ? 'accidente_transito' : 'asilo_en_corte',
    fecha_apertura: new Date().toISOString().split('T')[0],
    honorarios_total: 0
  });

  // ============ OPCIONES Y CONFIGURACIONES ============
  const opcionesMonitoreo = [
    { valor: 'sin_incidencia', label: 'Sin Incidencia', color: '#27ae60', icon: FiCheck },
    { valor: 'en_espera_documentos_cliente', label: 'En espera de documentos del cliente', color: '#64748b', icon: FiClock },
    { valor: 'rfe', label: 'RFE', color: '#f39c12', icon: FiAlertCircle },
    { valor: 'noid', label: 'NOID', color: '#e67e22', icon: FiAlertCircle },
    { valor: 'rfe_enviado', label: 'RFE Enviado', color: '#3498db', icon: FiSend },
    { valor: 'noid_enviado', label: 'NOID Enviado', color: '#9b59b6', icon: FiSend },
    { valor: 'en_apelacion', label: 'En Apelación', color: '#e74c3c', icon: FiInfo },
    { valor: 'demanda_presentada', label: 'Demanda Presentada', color: '#2563eb', icon: FiFileText },
    { valor: 'pendiente_envio_postal', label: 'Pendiente envío postal', color: '#d97706', icon: FiSend },
  ];

  const estadosUSA = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
    'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
    'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
    'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
    'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
  ];

  const paises = ['Estados Unidos', 'México', 'Colombia', 'Venezuela', 'Perú',
    'Argentina', 'Chile', 'Ecuador', 'Bolivia', 'Paraguay',
    'Uruguay', 'Brasil', 'Canadá', 'España', 'Reino Unido'
  ];

  const estadosActivos = ['activo', 'inactivo', 'pendiente', 'cerrado'];

  const tiposCaso = [
    { valor: 'asilo_en_corte', label: 'Asilo en Corte' },
    { valor: 'asilo_en_uscis', label: 'Asilo en USCIS' },
    { valor: 'habeas_corpus', label: 'Habeas Corpus / Bond Hearing' },
    { valor: 'peticion_familiar', label: 'Petición Familiar' },
    { valor: 'peticion_familiar_terminacion', label: 'Petición Familiar / Terminación en Corte' },
    { valor: 'peticion_familiar_ajuste', label: 'Petición Familiar + Ajuste de Estatus' },
    { valor: 'inversion_e2', label: 'Inversión E2' },
    { valor: 'visa_eb2_niw', label: 'Visa EB2 NIW' },
    { valor: 'visa_eb1', label: 'Visa EB-1' },
    { valor: 'visa_u', label: 'Visa U' },
    { valor: 'visa_t', label: 'Visa T' },
    { valor: 'vawa', label: 'VAWA' },
    { valor: 'estatus_juvenil_corte_familia', label: 'Estatus Juvenil — Corte de Familia' },
    { valor: 'estatus_juvenil_uscis', label: 'Estatus Juvenil — USCIS (SIJS)' },
    { valor: 'mandamus_federal', label: 'Mandamus — Corte Federal' },
    { valor: 'administrative_procedure_act_apa', label: 'Administrative Procedure Act (APA) — Corte Federal' },
    { valor: 'trust', label: 'Fideicomiso (Trust)' },
    { valor: 'accidente_transito', label: 'Accidente de Tránsito' },
  ];

  const tiposDocumento = ['identificacion', 'contrato', 'formulario', 'evidencia', 'propuesta'];
  const tiposComunicacion = ['llamada', 'email', 'mensaje_texto', 'carta'];
  const tiposEvento = ['audiencia', 'reunion', 'facturacion', 'otro'];

  // ============ CARGAR USUARIOS REALES ============
  const cargarUsuarios = async () => {
    try {
      const data = await usuarioService.getAll();
      setUsuarios(data);
    } catch (error) {
      console.error('Error al cargar usuarios:', error);
      // Fallback: usuarios simulados
      setUsuarios([]);
    } finally {
    }
  };

  // ============ CARGAR DATOS DEL BACKEND ============
  const cargarClientes = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/clientes/`);
      const baseClientes = response.data || [];
      // Opening the client workspace must never trigger one full-history
      // request per client. That fan-out saturated the shared Render instance
      // and made Panel, Tasks and WhatsApp appear slow as well. Full details
      // are loaded only for the client the user explicitly opens.
      setClientes(baseClientes);
    } catch (error) {
      console.error('Error al cargar clientes:', error);
      alert('❌ Error al cargar clientes. Verifica que el backend esté corriendo.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarClientes();
    cargarUsuarios();
    if (!personalInjury) {
      axios.get(`${API}/eoir/nationalities`)
        .then(response => setEoirNationalities(response.data?.nationalities || []))
        .catch(() => setEoirNationalities([]));
    }
  }, [personalInjury]);

  // ============ FUNCIONES AUXILIARES ============
  const getStatusColor = (estado) => {
    const colors = { activo: '#27ae60', inactivo: '#e74c3c', pendiente: '#f39c12', cerrado: '#95a5a6' };
    return colors[estado] || '#95a5a6';
  };

  const getStatusLabel = (estado) => {
    const labels = { activo: 'Activo', inactivo: 'Inactivo', pendiente: 'Pendiente', cerrado: 'Cerrado' };
    return labels[estado] || estado;
  };

  const getTipoCasoLabel = (tipo) => {
    const opcion = tiposCaso.find(t => t.valor === tipo);
    return opcion ? opcion.label : caseTypeLabel(tipo);
  };

  const renderMonitoreoBadge = (valor) => {
    const opcion = opcionesMonitoreo.find(o => o.valor === valor);
    if (!opcion) return <span>{valor}</span>;
    const Icon = opcion.icon;
    return (
      <span className="monitoreo-badge" style={{ backgroundColor: `${opcion.color}15`, color: opcion.color, borderColor: opcion.color }}>
        <Icon size={14} /> {opcion.label}
      </span>
    );
  };

  const getMetodoPagoLabel = (metodo) => {
    const labels = {
      zelle: '💳 Zelle',
      tarjeta_credito: '💳 Tarjeta Crédito',
      efectivo: '💵 Efectivo'
    };
    return labels[metodo] || metodo;
  };

  const getAreaPractica = (tipoCaso) => {
    const workspace = sectionForCaseType(tipoCaso);
    const areas = {
      eoir: 'EOIR / BIA', uscis: 'USCIS', civil: 'Casos civiles',
      accidentes: 'Accidentes', estate_planning: 'Estate Planning',
      consulado: 'Consulado Colombia'
    };
    return areas[workspace] || 'Expediente legal';
  };

  const toDate = (value) => {
    if (!value) return null;
    const date = new Date(`${value}`.length === 10 ? `${value}T12:00:00` : value);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const getNextAppointment = (cliente) => {
    const now = new Date(); now.setHours(0, 0, 0, 0);
    return [...(cliente.eventos || [])]
      .filter((evento) => toDate(evento.fecha) && toDate(evento.fecha) >= now)
      .sort((a, b) => toDate(a.fecha) - toDate(b.fecha))[0] || null;
  };

  const getLastActivity = (cliente) => {
    const items = [...(cliente.actividad || [])];
    return items.sort((a, b) => toDate(b.fecha_creacion || b.fecha) - toDate(a.fecha_creacion || a.fecha))[0] || null;
  };

  const getCaseHealth = (cliente) => {
    const monitoring = cliente.monitoreo || 'sin_incidencia';
    const next = getNextAppointment(cliente);
    const now = new Date(); now.setHours(0, 0, 0, 0);
    const withinSevenDays = next && ((toDate(next.fecha) - now) / 86400000) <= 7;
    const paid = (cliente.pagos || []).reduce((sum, payment) => sum + Number(payment.monto || 0), 0);
    const hasBalance = Number(cliente.honorarios_total || 0) > paid;
    if (monitoring === 'noid' || monitoring === 'en_apelacion') return { key: 'urgent', label: 'Urgente', tone: 'danger' };
    if (monitoring === 'rfe') return { key: 'rfe', label: 'RFE pendiente', tone: 'warning' };
    if (monitoring === 'en_espera_documentos_cliente') return { key: 'documents', label: 'Documentos pendientes', tone: 'slate' };
    if (monitoring === 'pendiente_envio_postal') return { key: 'postal', label: 'Pendiente envío postal', tone: 'warning' };
    if (next?.tipo === 'biometrics' || /biometric/i.test(next?.titulo || '')) return { key: 'biometrics', label: 'Biometrics', tone: 'purple' };
    if (withinSevenDays) return { key: 'hearing', label: 'Audiencia próxima', tone: 'orange' };
    if (hasBalance) return { key: 'payment', label: 'Pago pendiente', tone: 'warning' };
    return { key: 'current', label: 'Al día', tone: 'success' };
  };

  const isClosed = (cliente) => ['cerrado', 'archivado', 'inactivo'].includes((cliente.estado_activo || '').toLowerCase());
  const formatDate = (value, empty = 'Sin fecha') => formatDateUS(value, empty);
  const getAttorney = (cliente) => cliente.abogado_responsable || 'Sin asignar';

  const matchesQuickFilter = (cliente) => {
    const health = getCaseHealth(cliente).key;
    const next = getNextAppointment(cliente);
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const weekEnd = new Date(today); weekEnd.setDate(today.getDate() + 7);
    if (quickFilter === 'mi_cartera') return Boolean(cliente.abogado_responsable);
    if (quickFilter === 'atencion') return health !== 'current' && !isClosed(cliente);
    if (quickFilter === 'audiencias') return next && toDate(next.fecha) <= weekEnd;
    if (quickFilter === 'pagos') return health === 'payment';
    if (quickFilter === 'documentos') return health === 'documents';
    if (quickFilter === 'cerrados') return isClosed(cliente);
    if (quickFilter === 'activos') return !isClosed(cliente);
    return true;
  };

  // ============ FILTRADO Y ORDENAMIENTO ============
  const filteredClientes = clientes.filter(cliente => {
    const matchesSearch = `${cliente.nombre} ${cliente.apellido}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
      cliente.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      cliente.telefono?.includes(searchTerm);
    const matchesStatus = filterStatus === 'todos' || cliente.estado_activo === filterStatus;
    return matchesSearch && matchesStatus && matchesQuickFilter(cliente);
  });

  const sortedClientes = [...filteredClientes].sort((a, b) => {
    let aVal, bVal;
    if (sortBy === 'nombre') {
      aVal = `${a.nombre} ${a.apellido}`.toLowerCase();
      bVal = `${b.nombre} ${b.apellido}`.toLowerCase();
    } else {
      aVal = new Date(a.fecha_apertura);
      bVal = new Date(b.fecha_apertura);
    }
    return sortOrder === 'asc' ? (aVal > bVal ? 1 : -1) : (aVal < bVal ? 1 : -1);
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentClientes = sortedClientes.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(sortedClientes.length / itemsPerPage);

  // ============ FUNCIONES DE MANEJO ============
  
  const presentClientProfile = (data) => {
    setSelectedCliente(data);
    setEditCliente({
      id: data.id,
      nombre: data.nombre || '',
      apellido: data.apellido || '',
      fecha_nacimiento: usDateToISO(data.fecha_nacimiento) || data.fecha_nacimiento || '',
      direccion: data.direccion || '',
      ciudad: data.ciudad || '',
      codigo_postal: data.codigo_postal || '',
      estado: data.estado || 'FL',
      pais: data.pais || 'Estados Unidos',
      telefono: data.telefono || '',
      email: data.email || '',
      estado_activo: data.estado_activo || 'activo',
      monitoreo: data.monitoreo || 'sin_incidencia',
      abogado_responsable: data.abogado_responsable || '',
      a_number: data.a_number || '',
      nacionalidad: data.nacionalidad || '',
      numero_caso: data.numero_caso || '',
      tipo_caso: data.tipo_caso || 'asilo_en_corte',
      fecha_apertura: usDateToISO(data.fecha_apertura) || data.fecha_apertura || new Date().toISOString().split('T')[0],
      honorarios_total: data.honorarios_total || 0,
      dia_cobro_mensual: data.dia_cobro_mensual || ''
    });
  };

  const handleViewCliente = async (cliente) => {
    const requestId = ++profileRequest.current;
    try {
      // A portal token belongs to one client only. Never carry the previous
      // profile's temporary URL into the next client profile.
      setPortalUrl('');
      // The list already has enough safe profile data to open immediately.
      // Show it first, then hydrate the history, payments and documents in
      // the background. This avoids making the card feel unresponsive while
      // a client with a long history is being serialized by the API.
      const cached = clientes.find((item) => Number(item.id) === Number(cliente.id)) || cliente;
      presentClientProfile({
        ...cached,
        pagos: cached.pagos || [], tareas: cached.tareas || [], comunicaciones: cached.comunicaciones || [],
        documentos: cached.documentos || [], eventos: cached.eventos || [], actividad: cached.actividad || [],
        lista_documentos: cached.lista_documentos || [], expedientes: cached.expedientes || [],
      });
      setIsEditing(false);
      setActiveTab('informacion');
      setAiSummary('');
      setAiSummaryError('');
      setDriveDocuments([]);
      setDriveDocumentsError('');
      setDrivePath([]);
      setShowPerfil(true);
      const response = await axios.get(`${API}/clientes/${cliente.id}`);
      if (requestId !== profileRequest.current) return;
      presentClientProfile(response.data);
      if (response.data.drive_folder_id) {
        try {
          const drive = await axios.get(`${API}/google/drive/items`, { params: { folder_id: response.data.drive_folder_id, shared_drive_id: response.data.drive_shared_drive_id || undefined } });
          if (requestId !== profileRequest.current) return;
          setDriveDocuments(drive.data.items || []);
          setDrivePath([{ id: response.data.drive_folder_id, name: 'Carpeta del cliente' }]);
        } catch (driveError) {
          if (requestId !== profileRequest.current) return;
          setDriveDocumentsError(driveError.response?.data?.detail || 'No se pudo leer la carpeta vinculada de Google Drive.');
        }
      }
    } catch (error) {
      if (requestId !== profileRequest.current) return;
      console.error('Error al cargar cliente completo:', error);
      // The profile remains available from the cached list entry. Only show a
      // non-blocking warning if the detailed history could not be refreshed.
      setDriveDocumentsError('El perfil abrió con los datos disponibles; el historial completo se actualizará al reintentar.');
    }
  };

  useEffect(() => {
    const refreshClientHistory = async (event) => {
      const clienteId = Number(event.detail?.clienteId || 0);
      if (!clienteId || Number(selectedCliente?.id) !== clienteId) return;
      try {
        const { data } = await axios.get(`${API}/clientes/${clienteId}`);
        setSelectedCliente(data);
        setClientes((current) => current.map((client) => client.id === clienteId ? data : client));
      } catch {
        // The next profile refresh will retry; do not interrupt the user's current work.
      }
    };
    window.addEventListener('qlf-client-history-updated', refreshClientHistory);
    return () => window.removeEventListener('qlf-client-history-updated', refreshClientHistory);
  }, [selectedCliente?.id]);

  useEffect(() => {
    if (initialClientId && String(selectedCliente?.id) !== String(initialClientId)) {
      handleViewCliente({ id: initialClientId });
    }
  }, [initialClientId, selectedCliente?.id]);

  const closeClientProfile = () => {
    profileRequest.current += 1;
    setPortalUrl('');
    setShowPerfil(false);
    onProfileClosed?.();
  };

  const openDriveFolder = async (folder) => {
    try {
      const drive = await axios.get(`${API}/google/drive/items`, { params: { folder_id: folder.id, shared_drive_id: selectedCliente.drive_shared_drive_id || undefined } });
      setDriveDocuments(drive.data.items || []);
      setDrivePath((path) => [...path, { id: folder.id, name: folder.name }]);
      setDriveDocumentsError('');
    } catch (error) { setDriveDocumentsError(error.response?.data?.detail || 'No se pudo abrir la subcarpeta.'); }
  };

  const openDrivePath = async (index) => {
    const target = drivePath[index]; if (!target) return;
    try {
      const drive = await axios.get(`${API}/google/drive/items`, { params: { folder_id: target.id, shared_drive_id: selectedCliente.drive_shared_drive_id || undefined } });
      setDriveDocuments(drive.data.items || []); setDrivePath((path) => path.slice(0, index + 1));
    } catch (error) { setDriveDocumentsError(error.response?.data?.detail || 'No se pudo abrir esta carpeta.'); }
  };

  const createDriveSubfolder = async () => {
    const name = newDriveFolderName.trim();
    if (!name || !selectedCliente?.id) return;
    setCreatingDriveFolder(true);
    try {
      const { data } = await axios.post(`${API}/google/drive/client-subfolder`, { cliente_id: selectedCliente.id, name });
      setDriveDocuments((items) => [data.folder, ...items.filter((item) => item.id !== data.folder.id)]);
      setNewDriveFolderName('');
      setDriveDocumentsError('');
    } catch (error) {
      setDriveDocumentsError(error.response?.data?.detail || 'No se pudo crear la subcarpeta en Google Drive.');
    } finally {
      setCreatingDriveFolder(false);
    }
  };

  const closeDocumentPreview = () => {
    if (previewDocumentUrl) URL.revokeObjectURL(previewDocumentUrl);
    setPreviewDocumentUrl(''); setPreviewDocument(null); setPreviewDocumentLoading(false);
  };

  const openDocumentPreview = async (document) => {
    closeDocumentPreview();
    setPreviewDocument(document); setPreviewDocumentLoading(true);
    if (!document.drive_file_id && !document.mime_type) { setPreviewDocumentLoading(false); return; }
    const fileId = document.drive_file_id || document.id;
    try {
      const response = await axios.get(`${API}/google/drive/files/${fileId}/download`, { responseType: 'blob' });
      setPreviewDocumentUrl(URL.createObjectURL(response.data));
    } catch (error) {
      setDriveDocumentsError(error.response?.data?.detail || 'No se pudo cargar la vista previa del documento.');
    } finally { setPreviewDocumentLoading(false); }
  };

  const generateAiSummary = async () => {
    if (!selectedCliente) return;
    setAiSummaryLoading(true); setAiSummaryError('');
    try { const { data } = await axios.post(`${API}/clientes/${selectedCliente.id}/ai-summary`); setAiSummary(data.summary || 'Gemini no devolvió un resumen.'); setAiSummaryDrive(data.drive || null); }
    catch (error) { setAiSummaryError(error.response?.data?.detail || 'No se pudo generar el resumen IA.'); }
    finally { setAiSummaryLoading(false); }
  };

  const handleDeleteCliente = async (clienteId) => {
    if (!window.confirm('¿Estás seguro de eliminar este cliente?')) return;
    
    try {
      await axios.delete(`${API}/clientes/${clienteId}`);
      setClientes(clientes.filter(c => c.id !== clienteId));
      if (selectedCliente?.id === clienteId) closeClientProfile();
      alert('✅ Cliente eliminado exitosamente');
    } catch (error) {
      console.error('Error al eliminar cliente:', error);
      alert(`❌ ${error.response?.data?.detail || 'No fue posible eliminar el cliente.'}`);
    }
  };

  // ============ FUNCIONES PARA GUARDAR DATOS ============
  
  const handleSaveChanges = async () => {
    if (['fecha_nacimiento', 'fecha_apertura'].some(key => editCliente[key] && !/^\d{4}-\d{2}-\d{2}$/.test(editCliente[key]))) {
      alert('Ingrese una fecha válida en formato MM/DD/YYYY (mes/día/año).');
      return;
    }
    try {
      const { id, ...payload } = editCliente;
      payload.dia_cobro_mensual = payload.dia_cobro_mensual === '' || payload.dia_cobro_mensual == null ? null : Number(payload.dia_cobro_mensual);
      payload.honorarios_total = payload.honorarios_total === '' || payload.honorarios_total == null ? 0 : Number(payload.honorarios_total);
      const response = await axios.put(
        `${API}/clientes/${id}`,
        payload
      );
      setClientes(clientes.map(c => c.id === response.data.id ? response.data : c));
      setIsEditing(false);
      setSelectedCliente({ ...selectedCliente, ...response.data });
      alert('✅ Cliente actualizado exitosamente');
      if (sectionForCaseType(response.data.tipo_caso) === 'eoir') onCaseCreated?.('eoir');
    } catch (error) {
      console.error('Error al actualizar cliente:', error);
      alert(`❌ Error al actualizar el cliente: ${error.response?.data?.detail || 'Revise la conexión e intente nuevamente.'}`);
    }
  };

  // ============ FUNCIONES PARA TAREAS ============
  const handleAgregarTarea = async () => {
    if (taskRequestInFlight.current) return;
    if (!nuevaTarea.titulo.trim()) {
      alert('⚠️ El título de la tarea es obligatorio');
      return;
    }
    if (!nuevaTarea.asignado_a) {
      alert('⚠️ Debes asignar la tarea a un usuario');
      return;
    }

    taskRequestInFlight.current = true;
    setTaskSaving(true);
    try {
      const response = await axios.post(`${API}/clientes/tareas/`, {
        cliente_id: selectedCliente.id,
        titulo: nuevaTarea.titulo,
        descripcion: nuevaTarea.descripcion,
        completada: false,
        fecha: nuevaTarea.fecha,
        asignado_a: nuevaTarea.asignado_a,
        idempotency_key: window.crypto?.randomUUID?.() || `client-task-${Date.now()}`
      });

      const nuevaTareaObj = response.data;

      setClientes(clientes.map(c => 
        c.id === selectedCliente.id ? { 
          ...c, 
          tareas: [...(c.tareas || []), nuevaTareaObj] 
        } : c
      ));

      setSelectedCliente({
        ...selectedCliente,
        tareas: [...(selectedCliente.tareas || []), nuevaTareaObj]
      });

      setNuevaTarea({ titulo: '', descripcion: '', fecha: new Date().toISOString().split('T')[0], asignado_a: '' });
      setShowNuevaTarea(false);
      alert('✅ Tarea agregada exitosamente');
    } catch (error) {
      console.error('Error al agregar tarea:', error);
      alert('❌ Error al agregar la tarea');
    } finally {
      taskRequestInFlight.current = false;
      setTaskSaving(false);
    }
  };

  const handleToggleTarea = async (tareaId) => {
    const tarea = selectedCliente.tareas?.find(t => t.id === tareaId);
    if (!tarea) return;

    try {
      const response = await axios.put(
        `${API}/clientes/tareas/${tareaId}`,
        { completada: !tarea.completada }
      );

      setClientes(clientes.map(c => 
        c.id === selectedCliente.id ? { 
          ...c, 
          tareas: c.tareas.map(t => 
            t.id === tareaId ? response.data : t
          )
        } : c
      ));

      setSelectedCliente({
        ...selectedCliente,
        tareas: selectedCliente.tareas.map(t => 
          t.id === tareaId ? response.data : t
        )
      });
    } catch (error) {
      console.error('Error al actualizar tarea:', error);
      alert('❌ Error al actualizar la tarea');
    }
  };

  // ============ FUNCIONES PARA PAGOS ============
  const handleAgregarPago = async () => {
    if (!nuevoPago.monto || parseFloat(nuevoPago.monto) <= 0) {
      alert('⚠️ El monto debe ser mayor a 0');
      return;
    }

    try {
      const response = await axios.post(`${API}/clientes/pagos/`, {
        cliente_id: selectedCliente.id,
        monto: parseFloat(nuevoPago.monto),
        fecha: nuevoPago.fecha,
        concepto: nuevoPago.concepto || 'Pago general',
        metodo: nuevoPago.metodo
      });

      const nuevoPagoObj = response.data;

      setClientes(clientes.map(c => 
        c.id === selectedCliente.id ? { 
          ...c, 
          pagos: [...(c.pagos || []), nuevoPagoObj]
        } : c
      ));

      setSelectedCliente({
        ...selectedCliente,
        pagos: [...(selectedCliente.pagos || []), nuevoPagoObj]
      });

      setNuevoPago({ monto: '', fecha: new Date().toISOString().split('T')[0], concepto: '', metodo: 'zelle' });
      setShowNuevoPago(false);
      alert('✅ Pago registrado exitosamente');
    } catch (error) {
      console.error('Error al registrar pago:', error);
      alert('❌ Error al registrar el pago');
    }
  };

  const handleEditarPago = (pago) => {
    setEditandoPago({
      id: pago.id,
      monto: pago.monto,
      fecha: pago.fecha,
      concepto: pago.concepto,
      metodo: pago.metodo
    });
    setShowEditarPago(true);
  };

  const handleGuardarEdicionPago = async () => {
    if (!editandoPago.monto || parseFloat(editandoPago.monto) <= 0) {
      alert('⚠️ El monto debe ser mayor a 0');
      return;
    }

    try {
      const response = await axios.put(
        `${API}/clientes/pagos/${editandoPago.id}`,
        editandoPago
      );

      setClientes(clientes.map(c => 
        c.id === selectedCliente.id ? {
          ...c,
          pagos: c.pagos.map(p => 
            p.id === editandoPago.id ? response.data : p
          )
        } : c
      ));

      setSelectedCliente({
        ...selectedCliente,
        pagos: selectedCliente.pagos.map(p => 
          p.id === editandoPago.id ? response.data : p
        )
      });

      setShowEditarPago(false);
      setEditandoPago(null);
      alert('✅ Pago actualizado exitosamente');
    } catch (error) {
      console.error('Error al actualizar pago:', error);
      alert('❌ Error al actualizar el pago');
    }
  };

  const handleEliminarPago = async (pagoId) => {
    if (!window.confirm('¿Estás seguro de eliminar este pago?')) return;

    try {
      await axios.delete(`${API}/clientes/pagos/${pagoId}`);

      setClientes(clientes.map(c => 
        c.id === selectedCliente.id ? {
          ...c,
          pagos: c.pagos.filter(p => p.id !== pagoId)
        } : c
      ));

      setSelectedCliente({
        ...selectedCliente,
        pagos: selectedCliente.pagos.filter(p => p.id !== pagoId)
      });

      alert('✅ Pago eliminado exitosamente');
    } catch (error) {
      console.error('Error al eliminar pago:', error);
      alert('❌ Error al eliminar el pago');
    }
  };

  // ============ FUNCIONES PARA COMUNICACIONES ============
  const handleAgregarComunicacion = async () => {
    if (!nuevaComunicacion.mensaje.trim()) {
      alert('⚠️ El mensaje es obligatorio');
      return;
    }
    if (!nuevaComunicacion.realizada_por) {
      alert('⚠️ Debes seleccionar quién realizó la comunicación');
      return;
    }

    try {
      const response = await axios.post(`${API}/clientes/comunicaciones/`, {
        cliente_id: selectedCliente.id,
        ...nuevaComunicacion
      });

      const nuevaComObj = response.data;

      setClientes(clientes.map(c => 
        c.id === selectedCliente.id ? { 
          ...c, 
          comunicaciones: [...(c.comunicaciones || []), nuevaComObj] 
        } : c
      ));

      setSelectedCliente({
        ...selectedCliente,
        comunicaciones: [...(selectedCliente.comunicaciones || []), nuevaComObj]
      });

      setNuevaComunicacion({
        tipo: 'llamada',
        fecha: new Date().toISOString().split('T')[0],
        hora: new Date().toTimeString().slice(0, 5),
        realizada_por: '',
        mensaje: ''
      });
      setShowNuevaComunicacion(false);
      alert('✅ Comunicación agregada exitosamente');
    } catch (error) {
      console.error('Error al agregar comunicación:', error);
      alert('❌ Error al agregar la comunicación');
    }
  };

  const handleAgregarExpediente = async () => {
    if (!selectedCliente?.id) return;
    try {
      const { data } = await axios.post(`${API}/clientes/${selectedCliente.id}/expedientes`, { tipo_caso: nuevoTipoExpediente });
      setSelectedCliente((client) => ({ ...client, expedientes: [data, ...(client.expedientes || [])] }));
      setShowAgregarExpediente(false);
      onCaseCreated?.(data.workspace === 'accidentes' ? 'accidentes' : data.workspace);
    } catch (error) {
      alert(error.response?.data?.detail || 'No se pudo crear el expediente adicional.');
    }
  };

  const handleGeneratePortalLink = async () => {
    if (!selectedCliente || portalBusy) return;
    setPortalBusy(true);
    try {
      const { data } = await axios.post(`${API}/clientes/${selectedCliente.id}/expediente-virtual`);
      setPortalUrl(data.portal_url || '');
      if (data.portal_url && navigator.clipboard?.writeText) await navigator.clipboard.writeText(data.portal_url);
      alert('✅ Enlace de expediente virtual generado y copiado. Generar uno nuevo revoca el enlace anterior.');
    } catch (error) {
      alert(`❌ ${error.response?.data?.detail || 'No fue posible crear el enlace del expediente virtual.'}`);
    } finally { setPortalBusy(false); }
  };

  const handleAddDocumentCheck = async () => {
    if (!selectedCliente?.id || !nuevoDocumentoLista.trim()) return;
    try {
      const { data } = await axios.post(`${API}/clientes/${selectedCliente.id}/lista-documentos`, { nombre: nuevoDocumentoLista.trim() });
      setSelectedCliente(current => ({ ...current, lista_documentos: [...(current.lista_documentos || []), data] }));
      setNuevoDocumentoLista('');
    } catch (error) { alert(error.response?.data?.detail || 'No fue posible agregar el documento a la lista.'); }
  };

  const handleToggleDocumentCheck = async (item) => {
    try {
      const { data } = await axios.put(`${API}/clientes/${selectedCliente.id}/lista-documentos/${item.id}`, { completado: !item.completado });
      setSelectedCliente(current => ({ ...current, lista_documentos: (current.lista_documentos || []).map(entry => entry.id === item.id ? data : entry) }));
    } catch (error) { alert(error.response?.data?.detail || 'No fue posible actualizar la lista documental.'); }
  };

  const handleDeleteDocumentCheck = async (item) => {
    if (!window.confirm(`¿Quitar “${item.nombre}” de la lista documental?`)) return;
    try {
      await axios.delete(`${API}/clientes/${selectedCliente.id}/lista-documentos/${item.id}`);
      setSelectedCliente(current => ({ ...current, lista_documentos: (current.lista_documentos || []).filter(entry => entry.id !== item.id) }));
    } catch (error) { alert(error.response?.data?.detail || 'No fue posible quitar el documento.'); }
  };

  const handleUploadDocumento = async () => {
    if (!documentFile) return alert('Seleccione un archivo PDF, Word o imagen para subir.');
    if (!selectedCliente?.drive_folder_id) return alert('Este cliente necesita una carpeta Google Drive vinculada antes de subir documentos.');
    try {
      const data = new FormData(); data.append('cliente_id', selectedCliente.id); data.append('file', documentFile);
      const response = await axios.post(`${API}/google/drive/upload`, data, { headers: { 'Content-Type': 'multipart/form-data' } });
      const file = response.data.file;
      setDriveDocuments((items) => [{ ...file }, ...items]);
      setSelectedCliente((client) => ({ ...client, documentos: [...(client.documentos || []), { id: response.data.documento_id, nombre: file.name, tipo: 'drive', fecha: new Date().toISOString().slice(0, 10), web_view_link: file.web_view_link }] }));
      setDocumentFile(null); setNuevoDocumento({ nombre: '', tipo: 'identificacion', fecha: new Date().toISOString().split('T')[0] }); setShowNuevoDocumento(false);
      alert('Documento subido a Google Drive y asociado al cliente.');
    } catch (error) { alert(error.response?.data?.detail || 'No se pudo subir el documento a Google Drive.'); }
  };

  // ============ FUNCIONES PARA EVENTOS ============
  const handleAgregarEvento = async () => {
    if (!nuevoEvento.titulo.trim()) {
      alert('⚠️ El título del evento es obligatorio');
      return;
    }

    try {
      const response = await axios.post(`${API}/clientes/eventos/`, {
        cliente_id: selectedCliente.id,
        ...nuevoEvento
      });

      const nuevoEventoObj = response.data;

      setClientes(clientes.map(c => 
        c.id === selectedCliente.id ? {
          ...c,
          eventos: [...(c.eventos || []), nuevoEventoObj]
        } : c
      ));

      setSelectedCliente({
        ...selectedCliente,
        eventos: [...(selectedCliente.eventos || []), nuevoEventoObj]
      });

      setNuevoEvento({ titulo: '', fecha: new Date().toISOString().split('T')[0], tipo: 'reunion' });
      setShowNuevoEvento(false);
      alert('✅ Evento agregado exitosamente');
    } catch (error) {
      console.error('Error al agregar evento:', error);
      alert('❌ Error al agregar el evento');
    }
  };

  // ============ FUNCIONES PARA HONORARIOS ============
  const handleEditarHonorarios = () => {
    setEditarHonorarios({
      honorarios_total: selectedCliente?.honorarios_total || 0
    });
    setShowEditarHonorarios(true);
  };

  const handleGuardarHonorarios = async () => {
    if (editarHonorarios.honorarios_total < 0) {
      alert('⚠️ El monto no puede ser negativo');
      return;
    }

    try {
      const response = await axios.put(
        `${API}/clientes/${selectedCliente.id}`,
        { honorarios_total: parseFloat(editarHonorarios.honorarios_total) }
      );

      setClientes(clientes.map(c => 
        c.id === selectedCliente.id ? response.data : c
      ));

      setSelectedCliente({
        ...selectedCliente,
        honorarios_total: parseFloat(editarHonorarios.honorarios_total)
      });

      setShowEditarHonorarios(false);
      alert('✅ Honorarios actualizados exitosamente');
    } catch (error) {
      console.error('Error al actualizar honorarios:', error);
      alert('❌ Error al actualizar los honorarios');
    }
  };

  // ============ COMPONENTE TABLE ROW ============
  const TableRow = ({ cliente }) => (
    <tr className="table-row" key={cliente.id}>
      <td className="cell-client">
        <div className="client-info">
          <div className="client-avatar">{cliente.nombre?.[0] || '?'}{cliente.apellido?.[0] || '?'}</div>
          <div>
            <div className="client-name">{cliente.nombre} {cliente.apellido}</div>
            <div className="client-email">{cliente.email}</div>
          </div>
        </div>
      </td>
      <td className="cell-contact"><div className="contact-info"><FiPhone className="icon-small" /><span>{cliente.telefono}</span></div></td>
      <td className="cell-case"><span className="case-type">{getTipoCasoLabel(cliente.tipo_caso)}</span></td>
      <td className="cell-case-number"><span className="case-number">{cliente.numero_caso}</span></td>
      <td className="cell-monitoreo">{renderMonitoreoBadge(cliente.monitoreo || 'sin_incidencia')}</td>
      <td className="cell-status"><span className="status-badge" style={{ backgroundColor: getStatusColor(cliente.estado_activo) }}>{getStatusLabel(cliente.estado_activo)}</span></td>
      <td className="cell-date"><div className="date-info"><FiCalendar className="icon-small" />{cliente.fecha_apertura}</div></td>
      <td className="cell-actions">
        <div className="actions-group">
          <button className="action-btn view" onClick={() => handleViewCliente(cliente)} title="Ver perfil"><FiEye /></button>
          <button className="action-btn delete" onClick={() => handleDeleteCliente(cliente.id)} title="Eliminar"><FiTrash2 /></button>
        </div>
      </td>
    </tr>
  );

  // Expedientes visuales: el detalle se abre únicamente al seleccionar una tarjeta.
  const ClienteCard = ({ cliente }) => {
    const isClosed = cliente.estado_activo === 'cerrado';
    const initials = `${cliente.nombre?.[0] || '?'}${cliente.apellido?.[0] || '?'}`;
    return (
      <button
        type="button"
        className={`cliente-case-card ${isClosed ? 'is-closed' : 'is-active'}`}
        onClick={() => handleViewCliente(cliente)}
        aria-label={`Abrir expediente de ${cliente.nombre} ${cliente.apellido}`}
      >
        <div className="cliente-case-card-header">
          <div className="cliente-card-person">
            <span className="cliente-card-avatar">{initials}</span>
            <span>
              <strong>{cliente.nombre} {cliente.apellido}</strong>
              <small>{cliente.email || 'Sin correo registrado'}</small>
            </span>
          </div>
          <div className="cliente-card-health">
            <span className="cliente-card-status" style={{ backgroundColor: getStatusColor(cliente.estado_activo) }}>
              {getStatusLabel(cliente.estado_activo)}
            </span>
            <span className="cliente-card-monitoring">{renderMonitoreoBadge(cliente.monitoreo || 'sin_incidencia')}</span>
          </div>
        </div>
        <div className="cliente-case-card-body">
          <div><FiBriefcase /><span>{getTipoCasoLabel(cliente.tipo_caso)}</span></div>
          <div><FiFileText /><span>{cliente.numero_caso || cliente.a_number || 'Número pendiente'}</span></div>
          <div><FiPhone /><span>{cliente.telefono || 'Teléfono pendiente'}</span></div>
        </div>
        <div className="cliente-case-card-footer">
          <span>{isClosed ? 'Expediente cerrado' : 'Expediente activo'}</span>
          <span className="cliente-card-open">Abrir expediente <FiChevronRight /></span>
        </div>
      </button>
    );
  };

  const WorkspaceClienteCard = ({ cliente }) => {
    const health = getCaseHealth(cliente);
    const next = getNextAppointment(cliente);
    const activity = getLastActivity(cliente);
    const initials = `${cliente.nombre?.[0] || '?'}${cliente.apellido?.[0] || '?'}`;
    return (
      <article className={`client-workspace-card ${isClosed(cliente) ? 'is-closed' : ''}`} onClick={() => handleViewCliente(cliente)} role="button" tabIndex={0} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); handleViewCliente(cliente); } }}>
        <header>
          <div className="client-workspace-person"><span className="client-workspace-avatar">{initials}</span><div><h3>{cliente.nombre} {cliente.apellido}</h3><p>{getAreaPractica(cliente.tipo_caso)}</p></div></div>
          <span className={`case-health-badge tone-${health.tone}`}>{health.label}</span>
        </header>
        <div className="client-workspace-case"><FiBriefcase /><div><span>Expediente</span><strong>{getTipoCasoLabel(cliente.tipo_caso) || 'Tipo pendiente'}</strong></div></div>
        <div className="client-workspace-statuses"><span className={`matter-status status-${cliente.estado_activo || 'pendiente'}`}>{getStatusLabel(cliente.estado_activo)}</span>{cliente.monitoreo && cliente.monitoreo !== 'sin_incidencia' && renderMonitoreoBadge(cliente.monitoreo)}</div>
        <dl className="client-workspace-meta"><div><dt>Attorney</dt><dd>{getAttorney(cliente)}</dd></div><div><dt>Próxima cita</dt><dd>{next ? formatDate(next.fecha) : 'Sin cita programada'}</dd></div><div><dt>Última actividad</dt><dd>{activity?.accion || 'Sin actividad registrada'}</dd></div><div><dt>Creado</dt><dd>{formatDate(cliente.fecha_creacion || cliente.fecha_apertura)}</dd></div></dl>
        <footer><span>{cliente.numero_caso || cliente.a_number || 'Número pendiente'}</span><div><button type="button" onClick={(event) => { event.stopPropagation(); handleViewCliente(cliente); }}>Abrir expediente <FiChevronRight /></button><button type="button" className="workspace-delete-client" onClick={(event) => { event.stopPropagation(); handleDeleteCliente(cliente.id); }} title="Eliminar cliente de prueba"><FiTrash2 /> Eliminar</button></div></footer>
      </article>
    );
  };

  const WorkspaceTable = () => (
    <div className="client-workspace-table-wrap"><table className="client-workspace-table"><thead><tr><th>Cliente</th>{visibleColumns.area && <th>Área</th>}{visibleColumns.caso && <th>Caso</th>}{visibleColumns.estado && <th>Estado</th>}{visibleColumns.attorney && <th>Attorney</th>}{visibleColumns.cita && <th>Próxima cita</th>}{visibleColumns.actividad && <th>Última actividad</th>}{visibleColumns.salud && <th>Salud</th>}<th aria-label="Abrir" /></tr></thead><tbody>{currentClientes.map((cliente) => { const health = getCaseHealth(cliente); const next = getNextAppointment(cliente); const activity = getLastActivity(cliente); return <tr key={cliente.id} onClick={() => handleViewCliente(cliente)}><td><div className="workspace-table-person"><span>{cliente.nombre?.[0] || '?'}{cliente.apellido?.[0] || '?'}</span><div><b>{cliente.nombre} {cliente.apellido}</b><small>{cliente.numero_caso || cliente.a_number || 'Número pendiente'}</small></div></div></td>{visibleColumns.area && <td>{getAreaPractica(cliente.tipo_caso)}</td>}{visibleColumns.caso && <td>{getTipoCasoLabel(cliente.tipo_caso)}</td>}{visibleColumns.estado && <td><span className={`matter-status status-${cliente.estado_activo || 'pendiente'}`}>{getStatusLabel(cliente.estado_activo)}</span></td>}{visibleColumns.attorney && <td>{getAttorney(cliente)}</td>}{visibleColumns.cita && <td>{next ? formatDate(next.fecha) : '—'}</td>}{visibleColumns.actividad && <td>{activity?.accion || '—'}</td>}{visibleColumns.salud && <td><span className={`case-health-badge tone-${health.tone}`}>{health.label}</span></td>}<td><button type="button" className="workspace-open-icon" onClick={(event) => { event.stopPropagation(); handleViewCliente(cliente); }}><FiChevronRight /></button></td></tr>; })}</tbody></table></div>
  );

  const WorkspacePipeline = () => {
    const stages = [{ key: 'active', label: 'Activos', test: (item) => !isClosed(item) && getCaseHealth(item).key === 'current' }, { key: 'attention', label: 'Atención requerida', test: (item) => !isClosed(item) && getCaseHealth(item).key !== 'current' }, { key: 'pending', label: 'Pendientes', test: (item) => item.estado_activo === 'pendiente' }, { key: 'closed', label: 'Cerrados', test: isClosed }];
    return <div className="client-workspace-pipeline">{stages.map((stage) => <section key={stage.key}><header><b>{stage.label}</b><span>{filteredClientes.filter(stage.test).length}</span></header><div>{currentClientes.filter(stage.test).map((cliente) => <button type="button" key={cliente.id} onClick={() => handleViewCliente(cliente)}><strong>{cliente.nombre} {cliente.apellido}</strong><small>{getTipoCasoLabel(cliente.tipo_caso)}</small><span className={`case-health-badge tone-${getCaseHealth(cliente).tone}`}>{getCaseHealth(cliente).label}</span></button>) || null}</div></section>)}</div>;
  };

  const guardarDiaCobro = async (dia) => {
    try {
      const response = await axios.put(`${API}/clientes/${selectedCliente.id}`, { dia_cobro_mensual: dia ? Number(dia) : null });
      setSelectedCliente({ ...selectedCliente, dia_cobro_mensual: response.data.dia_cobro_mensual });
      setClientes(clientes.map((client) => client.id === selectedCliente.id ? { ...client, dia_cobro_mensual: response.data.dia_cobro_mensual } : client));
    } catch (error) { alert('No se pudo guardar el día de cobro.'); }
  };

  // ============ RENDERIZADO PRINCIPAL ============
  return (
    <div className="clientes-module">
      {!showPerfil && <section className="clientes-workspace" aria-label="Clientes y expedientes">
        <header className="clientes-workspace-hero">
          <div><p className="workspace-eyebrow">GESTIÓN DE EXPEDIENTES</p><h1>👥 Clientes y Expedientes</h1><p>Prioriza hoy la cartera, las audiencias, documentos y cobros de cada cliente.</p></div>
          <button className="qlf-button qlf-button-primary" onClick={() => setShowAgregarCaso(true)}><FiPlus /> Nuevo cliente</button>
        </header>
        <div className="client-kpi-grid">
          <button onClick={() => { setQuickFilter('activos'); setCurrentPage(1); }}><span className="kpi-icon blue"><FiUsers /></span><div><small>Clientes activos</small><strong>{clientes.filter((item) => !isClosed(item)).length}</strong><em>Ver cartera activa</em></div></button>
          <button onClick={() => { setQuickFilter('activos'); setCurrentPage(1); }}><span className="kpi-icon navy"><FiBriefcase /></span><div><small>Casos abiertos</small><strong>{clientes.filter((item) => !isClosed(item)).length}</strong><em>Expedientes en curso</em></div></button>
          <button onClick={() => { setQuickFilter('atencion'); setCurrentPage(1); }}><span className="kpi-icon orange"><FiAlertTriangle /></span><div><small>Atención requerida</small><strong>{clientes.filter((item) => !isClosed(item) && getCaseHealth(item).key !== 'current').length}</strong><em>Revisar prioridades</em></div></button>
          <button onClick={() => { setQuickFilter('audiencias'); setCurrentPage(1); }}><span className="kpi-icon purple"><FiCalendar /></span><div><small>Audiencias próximas</small><strong>{clientes.filter((item) => { const next = getNextAppointment(item); return next && ((toDate(next.fecha) - new Date()) / 86400000) <= 7; }).length}</strong><em>Próximos 7 días</em></div></button>
          <button onClick={() => { setQuickFilter('pagos'); setCurrentPage(1); }}><span className="kpi-icon green"><FiCreditCard /></span><div><small>Pagos pendientes</small><strong>{clientes.filter((item) => getCaseHealth(item).key === 'payment').length}</strong><em>Saldo por cobrar</em></div></button>
          <button onClick={() => { setQuickFilter('documentos'); setCurrentPage(1); }}><span className="kpi-icon slate"><FiFolderMinus /></span><div><small>Documentos pendientes</small><strong>{clientes.filter((item) => getCaseHealth(item).key === 'documents').length}</strong><em>Solicitar seguimiento</em></div></button>
          <button onClick={() => { setQuickFilter('todos'); setCurrentPage(1); }}><span className="kpi-icon teal"><FiShield /></span><div><small>Casos al día</small><strong>{clientes.filter((item) => !isClosed(item) && getCaseHealth(item).key === 'current').length}</strong><em>Sin alertas actuales</em></div></button>
        </div>
        <div className="workspace-client-controls">
          <div className="search-box"><FiSearch className="search-icon" /><input type="text" placeholder="Buscar cliente, A-Number, correo o teléfono…" value={searchTerm} onChange={(event) => { setSearchTerm(event.target.value); setCurrentPage(1); }} className="search-input" />{searchTerm && <button className="search-clear" onClick={() => setSearchTerm('')}><FiX /></button>}</div>
          <select className="filter-select" value={filterStatus} onChange={(event) => { setFilterStatus(event.target.value); setCurrentPage(1); }}><option value="todos">Todos los estados</option><option value="activo">Activo</option><option value="pendiente">Pendiente</option><option value="cerrado">Cerrado</option><option value="inactivo">Inactivo</option></select>
          <div className="workspace-view-switch" aria-label="Cambiar vista"><button className={viewMode === 'cards' ? 'active' : ''} title="Tarjetas" onClick={() => setViewMode('cards')}><FiGrid /></button><button className={viewMode === 'table' ? 'active' : ''} title="Tabla" onClick={() => setViewMode('table')}><FiList /></button><button className={viewMode === 'pipeline' ? 'active' : ''} title="Pipeline" onClick={() => setViewMode('pipeline')}><FiColumns /></button></div>
          {viewMode === 'table' && <details className="column-picker"><summary><FiColumns /> Columnas</summary>{Object.entries({ area: 'Área', caso: 'Caso', estado: 'Estado', attorney: 'Attorney', cita: 'Próxima cita', actividad: 'Última actividad', salud: 'Salud' }).map(([key, label]) => <label key={key}><input type="checkbox" checked={visibleColumns[key]} onChange={() => setVisibleColumns((value) => ({ ...value, [key]: !value[key] }))} />{label}</label>)}</details>}
          <button className="qlf-button qlf-button-secondary workspace-refresh" title="Actualizar cartera" onClick={cargarClientes}><FiRefreshCw /> Actualizar</button>
        </div>
        <div className="quick-filter-row">{[['todos','Todos'], ['mi_cartera','Mi cartera'], ['atencion','Atención requerida'], ['audiencias','Audiencias esta semana'], ['pagos','Pagos pendientes'], ['documentos','Documentos pendientes'], ['activos','Casos activos'], ['cerrados','Casos cerrados']].map(([key, label]) => <button key={key} className={quickFilter === key ? 'active' : ''} onClick={() => { setQuickFilter(key); setCurrentPage(1); }}>{label}</button>)}</div>
        <div className="workspace-results-heading"><div><h2>Expedientes</h2><p>{filteredClientes.length} resultados · datos sincronizados con los expedientes</p></div><span>{viewMode === 'cards' ? 'Vista de tarjetas' : viewMode === 'table' ? 'Vista de tabla' : 'Vista de pipeline'}</span></div>
        {loading ? <div className="clientes-grid-state"><div className="loader" /><p>Cargando expedientes…</p></div> : currentClientes.length === 0 ? <div className="clientes-grid-state empty-state"><FiBriefcase className="empty-icon" /><h3>No hay expedientes para este filtro</h3><p>Prueba otra vista o crea un nuevo cliente.</p></div> : <>{viewMode === 'cards' && <section className="client-workspace-card-grid">{currentClientes.map((cliente) => <WorkspaceClienteCard key={cliente.id} cliente={cliente} />)}</section>}{viewMode === 'table' && <WorkspaceTable />}{viewMode === 'pipeline' && <WorkspacePipeline />}</>}
        {filteredClientes.length > itemsPerPage && <div className="pagination"><button className="page-btn" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>Anterior</button><span className="page-info">Página {currentPage} de {totalPages}</span><button className="page-btn" disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>Siguiente</button></div>}
        <section className="workspace-recent-activity"><header><div><p className="workspace-eyebrow">MOVIMIENTO RECIENTE</p><h2><FiActivity /> Actividad reciente</h2></div></header><div>{clientes.flatMap((cliente) => (cliente.actividad || []).map((activity) => ({ ...activity, cliente }))).sort((a, b) => toDate(b.fecha_creacion || b.fecha) - toDate(a.fecha_creacion || a.fecha)).slice(0, 6).map((activity) => <button key={`${activity.cliente.id}-${activity.id}`} onClick={() => handleViewCliente(activity.cliente)}><span><FiActivity /></span><div><b>{activity.accion}</b><p>{activity.cliente.nombre} {activity.cliente.apellido} · {activity.usuario || 'Sistema'}</p></div><time>{formatDate(activity.fecha_creacion || activity.fecha)}</time></button>) || <p className="activity-empty">Las actuaciones reales del equipo aparecerán aquí.</p>}</div></section>
      </section>}
      {/* Header */}
      <div className="clientes-header">
        <div className="clientes-title-section">
          <h1>👤 Clientes</h1>
          <p>Gestión completa de clientes y sus casos</p>
        </div>
        <button className="btn-agregar-cliente" onClick={() => setShowAgregarCaso(true)}>
          <FiPlus /> Nuevo Cliente
        </button>
      </div>

      {/* Toolbar */}
      <div className="clientes-toolbar">
        <div className="search-box">
          <FiSearch className="search-icon" />
          <input type="text" placeholder="Buscar por nombre, email o teléfono..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="search-input" />
          {searchTerm && <button className="search-clear" onClick={() => setSearchTerm('')}><FiX /></button>}
        </div>
        <div className="toolbar-filters">
          <select className="filter-select" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
            <option value="todos">Todos los estados</option>
            <option value="activo">Activo</option>
            <option value="inactivo">Inactivo</option>
            <option value="pendiente">Pendiente</option>
            <option value="cerrado">Cerrado</option>
          </select>
          <button className="btn-sort" onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}>
            {sortOrder === 'asc' ? <FiArrowUp /> : <FiArrowDown />}
          </button>
          <button className="btn-refresh" onClick={cargarClientes}><FiRefreshCw /></button>
        </div>
      </div>

      {/* Contador */}
      <div className="clientes-counter">
        <span>{filteredClientes.length} clientes encontrados</span>
      </div>

      {/* Tabla */}
      <section className="clientes-case-grid" aria-label="Expedientes de clientes">
        {loading ? (
          <div className="clientes-grid-state"><div className="loader"></div><p>Cargando clientes...</p></div>
        ) : currentClientes.length === 0 ? (
          <div className="clientes-grid-state empty-state"><FiUser className="empty-icon" /><h3>No hay clientes</h3><p>Agrega tu primer cliente usando el botón “Nuevo Cliente”.</p></div>
        ) : (
          currentClientes.map(cliente => <ClienteCard key={cliente.id} cliente={cliente} />)
        )}
      </section>

      <div className="clientes-table-container clientes-table-legacy" aria-hidden="true">
        <table className="clientes-table">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Contacto</th>
              <th>Tipo de Caso</th>
              <th>Número de Caso</th>
              <th>Monitoreo</th>
              <th>Estado</th>
              <th>Fecha</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" className="loading-cell"><div className="loader"></div><p>Cargando clientes...</p></td></tr>
            ) : currentClientes.length === 0 ? (
              <tr><td colSpan="8" className="empty-cell"><div className="empty-state"><FiUser className="empty-icon" /><h3>No hay clientes</h3><p>Agrega tu primer cliente usando el botón "Nuevo Cliente"</p></div></td></tr>
            ) : (
              currentClientes.map(cliente => <TableRow key={cliente.id} cliente={cliente} />)
            )}
          </tbody>
        </table>
      </div>

      {/* Paginación */}
      {filteredClientes.length > itemsPerPage && (
        <div className="pagination">
          <button className="page-btn" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>Anterior</button>
          <span className="page-info">Página {currentPage} de {totalPages}</span>
          <button className="page-btn" disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>Siguiente</button>
        </div>
      )}

      {/* ============ PERFIL DEL CLIENTE ============ */}
      {showPerfil && selectedCliente && (
        <div className="client-profile-page">
          <section className="client-profile-workspace" aria-label="Expediente del cliente">
            {/* Header */}
            <div className="perfil-header">
              <div className="perfil-header-left">
                <div className="perfil-avatar-large">{selectedCliente.nombre?.[0] || '?'}{selectedCliente.apellido?.[0] || '?'}</div>
                <div>
                  <h2>{selectedCliente.nombre} {selectedCliente.apellido}</h2>
                  <div className="perfil-subtitle">
                    <span className="perfil-case">{getTipoCasoLabel(selectedCliente.tipo_caso)}</span>
                    <span className="perfil-separator">•</span>
                    <span className="perfil-status" style={{ color: getStatusColor(selectedCliente.estado_activo) }}>{getStatusLabel(selectedCliente.estado_activo)}</span>
                    <span className="perfil-separator">•</span>
                    {renderMonitoreoBadge(selectedCliente.monitoreo || 'sin_incidencia')}
                  </div>
                </div>
              </div>
              <div className="perfil-header-right">
                <button className="btn-edit-perfil" onClick={() => setIsEditing(!isEditing)}>
                  {isEditing ? <FiX /> : <FiEdit2 />} {isEditing ? 'Cancelar' : 'Editar'}
                </button>
                <button className="btn-close-perfil" onClick={closeClientProfile}>← Volver a clientes</button>
              </div>
            </div>

            {/* Tabs */}
            <div className="perfil-tabs-container">
              <div className="perfil-tabs">
                <button className={`perfil-tab ${activeTab === 'informacion' ? 'active' : ''}`} onClick={() => setActiveTab('informacion')}><FiUser /> Información</button>
                <button className={`perfil-tab ${activeTab === 'documentos' ? 'active' : ''}`} onClick={() => setActiveTab('documentos')}><FiFolder /> Documentos</button>
                <button className={`perfil-tab ${activeTab === 'lista_documentos' ? 'active' : ''}`} onClick={() => setActiveTab('lista_documentos')}><FiCheckSquare /> Lista documentos</button>
                <button className={`perfil-tab ${activeTab === 'ia' ? 'active' : ''}`} onClick={() => setActiveTab('ia')}><span>🤖</span> Resumen IA</button>
                <button className={`perfil-tab ${activeTab === 'tareas' ? 'active' : ''}`} onClick={() => setActiveTab('tareas')}><FiCheckCircle /> Tareas</button>
                <button className={`perfil-tab ${activeTab === 'comunicaciones' ? 'active' : ''}`} onClick={() => setActiveTab('comunicaciones')}><FiMessageCircle /> Comunicaciones</button>
                <button className={`perfil-tab ${activeTab === 'finanzas' ? 'active' : ''}`} onClick={() => setActiveTab('finanzas')}><FiDollarSign /> Pagos</button>
                <button className={`perfil-tab ${activeTab === 'historial' ? 'active' : ''}`} onClick={() => setActiveTab('historial')}><FiClock /> Historial</button>
              </div>
            </div>

            {/* ============ CONTENIDO DEL PERFIL ============ */}
            <div className="perfil-body">

              {/* ===== INFORMACIÓN ===== */}
              {activeTab === 'informacion' && (
                <div className="perfil-content">
                  {/* Información Personal */}
                  <div className="perfil-section">
                    <h3><FiUser className="section-icon" /> Información Personal</h3>
                    <div className="info-grid">
                      <div className="info-item">
                        <label>Nombre *</label>
                        {isEditing ? (
                          <input value={editCliente.nombre} onChange={(e) => setEditCliente({...editCliente, nombre: e.target.value})} />
                        ) : (
                          <span>{selectedCliente.nombre}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Apellido *</label>
                        {isEditing ? (
                          <input value={editCliente.apellido} onChange={(e) => setEditCliente({...editCliente, apellido: e.target.value})} />
                        ) : (
                          <span>{selectedCliente.apellido}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Fecha de Nacimiento (MM/DD/YYYY)</label>
                        {isEditing ? (
                          <USDateInput value={editCliente.fecha_nacimiento} onChange={(e) => setEditCliente({...editCliente, fecha_nacimiento: e.target.value})} />
                        ) : (
                          <span>{formatDateUS(selectedCliente.fecha_nacimiento, 'No registrada')}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Email *</label>
                        {isEditing ? (
                          <input type="email" value={editCliente.email} onChange={(e) => setEditCliente({...editCliente, email: e.target.value})} />
                        ) : (
                          <span>{selectedCliente.email}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Teléfono *</label>
                        {isEditing ? (
                          <input value={editCliente.telefono} onChange={(e) => setEditCliente({...editCliente, telefono: e.target.value})} />
                        ) : (
                          <span>{selectedCliente.telefono}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Dirección</label>
                        {isEditing ? (
                          <input value={editCliente.direccion} onChange={(e) => setEditCliente({...editCliente, direccion: e.target.value})} />
                        ) : (
                          <span>{selectedCliente.direccion || 'No registrada'}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Ciudad</label>
                        {isEditing ? (
                          <input value={editCliente.ciudad} onChange={(e) => setEditCliente({...editCliente, ciudad: e.target.value})} />
                        ) : (
                          <span>{selectedCliente.ciudad || 'No registrada'}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Estado</label>
                        {isEditing ? (
                          <select value={editCliente.estado} onChange={(e) => setEditCliente({...editCliente, estado: e.target.value})}>
                            {estadosUSA.map(est => <option key={est} value={est}>{est}</option>)}
                          </select>
                        ) : (
                          <span>{selectedCliente.estado || 'No registrado'}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>ZIP Code / Código postal</label>
                        {isEditing ? <input value={editCliente.codigo_postal || ''} maxLength={16} autoComplete="postal-code" onChange={e => setEditCliente({...editCliente, codigo_postal: e.target.value})} /> : <span>{selectedCliente.codigo_postal || 'No registrado'}</span>}
                      </div>
                      <div className="info-item">
                        <label>País</label>
                        {isEditing ? (
                          <select value={editCliente.pais} onChange={(e) => setEditCliente({...editCliente, pais: e.target.value})}>
                            {paises.map(p => <option key={p} value={p}>{p}</option>)}
                          </select>
                        ) : (
                          <span>{selectedCliente.pais || 'Estados Unidos'}</span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Información Legal */}
                  <div className="perfil-section">
                    <h3><FiBriefcase className="section-icon" /> Información Legal</h3>
                    <div className="info-grid">
                      <div className="info-item">
                        <label>Tipo de Caso</label>
                        {isEditing ? (
                          <select value={editCliente.tipo_caso} onChange={(e) => setEditCliente({...editCliente, tipo_caso: e.target.value})}>
                            {tiposCaso.filter(t => !personalInjury || t.valor === 'accidente_transito').map(t => <option key={t.valor} value={t.valor}>{t.label}</option>)}
                          </select>
                        ) : (
                          <span>{getTipoCasoLabel(selectedCliente.tipo_caso)}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>A-Number</label>
                        {isEditing ? (
                          <input value={editCliente.a_number} onChange={(e) => setEditCliente({...editCliente, a_number: e.target.value})} placeholder="A123456789" />
                        ) : (
                          <span>{selectedCliente.a_number || 'No registrado'}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Nacionalidad</label>
                        {isEditing ? (
                          <select value={editCliente.nacionalidad} onChange={(e) => setEditCliente({...editCliente, nacionalidad: e.target.value})}>
                            <option value="">Selecciona nacionalidad…</option>
                            {eoirNationalities.map(nationality => <option key={nationality} value={nationality}>{nationality}</option>)}
                          </select>
                        ) : (
                          <span>{selectedCliente.nacionalidad || 'No registrada'}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Número de Caso</label>
                        {isEditing ? (
                          <input value={editCliente.numero_caso} onChange={(e) => setEditCliente({...editCliente, numero_caso: e.target.value})} />
                        ) : (
                          <span>{selectedCliente.numero_caso || 'No registrado'}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Abogado Responsable</label>
                        {isEditing ? (
                          <select value={editCliente.abogado_responsable} onChange={(e) => setEditCliente({...editCliente, abogado_responsable: e.target.value})}>
                            <option value="">Seleccionar...</option>
                            {usuarios.map(u => <option key={u.id} value={u.nombre}>{u.nombre}</option>)}
                          </select>
                        ) : (
                          <span>{selectedCliente.abogado_responsable || 'Sin asignar'}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Fecha de Apertura (MM/DD/YYYY)</label>
                        {isEditing ? (
                          <USDateInput value={editCliente.fecha_apertura} onChange={(e) => setEditCliente({...editCliente, fecha_apertura: e.target.value})} />
                        ) : (
                          <span>{formatDateUS(selectedCliente.fecha_apertura)}</span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Estado del Cliente</label>
                        {isEditing ? (
                          <select value={editCliente.estado_activo} onChange={(e) => setEditCliente({...editCliente, estado_activo: e.target.value})}>
                            {estadosActivos.map(est => <option key={est} value={est}>{est.charAt(0).toUpperCase() + est.slice(1)}</option>)}
                          </select>
                        ) : (
                          <span className="status-badge" style={{ backgroundColor: getStatusColor(selectedCliente.estado_activo) }}>
                            {getStatusLabel(selectedCliente.estado_activo)}
                          </span>
                        )}
                      </div>
                      <div className="info-item">
                        <label>Monitoreo</label>
                        {isEditing ? (
                          <select value={editCliente.monitoreo} onChange={(e) => setEditCliente({...editCliente, monitoreo: e.target.value})}>
                            {opcionesMonitoreo.map(o => <option key={o.valor} value={o.valor}>{o.label}</option>)}
                          </select>
                        ) : (
                          renderMonitoreoBadge(selectedCliente.monitoreo || 'sin_incidencia')
                        )}
                      </div>
                    </div>
                    {isEditing && (
                      <div className="edit-actions">
                        <button className="btn-save-perfil" onClick={handleSaveChanges}><FiSave /> Guardar Cambios</button>
                      </div>
                    )}
                    <div className="client-portal-link">
                      <div><b><FiLink /> Expediente virtual del cliente</b><small>Enlace seguro y revocable para consultar actuaciones y cargar archivos.</small></div>
                      <button type="button" className="btn-agregar-documento" onClick={handleGeneratePortalLink} disabled={portalBusy}>{portalBusy ? 'Generando…' : 'Generar y copiar enlace'}</button>
                      {portalUrl && <input readOnly value={portalUrl} aria-label="Enlace de expediente virtual" onFocus={(event) => event.target.select()} />}
                    </div>
                  </div>

                  <div className="perfil-section client-matters-panel">
                    <div className="section-header-actions">
                      <div><h3><FiBriefcase className="section-icon" /> Expedientes del cliente</h3><p>Un mismo cliente puede tener varios asuntos sin duplicar su información.</p></div>
                      {!personalInjury && <button className="btn-agregar-documento" onClick={() => setShowAgregarExpediente(true)}><FiPlus /> Añadir caso</button>}
                    </div>
                    <div className="client-matters-list">
                      <article className="client-matter-chip primary"><span>📂</span><div><b>{getTipoCasoLabel(selectedCliente.tipo_caso)}</b><small>Caso principal · {sectionForCaseType(selectedCliente.tipo_caso).toUpperCase()}</small></div></article>
                      {(selectedCliente.expedientes || []).map((matter) => <article className="client-matter-chip" key={matter.id}><span>{matter.workspace === 'eoir' ? '⚖️' : matter.workspace === 'uscis' ? '🛂' : matter.workspace === 'civil' ? '🏛️' : '🚗'}</span><div><b>{getTipoCasoLabel(matter.tipo_caso)}</b><small>{matter.workspace === 'eoir' ? 'EOIR/BIA' : matter.workspace === 'uscis' ? 'USCIS' : matter.workspace === 'civil' ? 'Casos civiles' : 'Accidentes'} · Activo</small></div></article>)}
                    </div>
                  </div>

                  {/* Calendario de Eventos */}
                  <div className="perfil-section">
                    <div className="section-header-actions">
                      <h3><FiCalendar className="section-icon" /> Calendario de Eventos</h3>
                      <button className="btn-agregar-evento" onClick={() => setShowNuevoEvento(true)}>
                        <FiPlus /> Agregar Evento
                      </button>
                    </div>
                    <div className="calendario-container">
                      <div className="calendario-wrapper">
                        <Calendar 
                          value={new Date()} 
                          onChange={(date) => {
                            const eventosDia = selectedCliente.eventos?.filter(e => 
                              new Date(e.fecha).toDateString() === date.toDateString()
                            ) || [];
                            if (eventosDia.length > 0) {
                              alert(`Eventos para ${date.toLocaleDateString('en-US')}:\n${eventosDia.map(e => `- ${e.titulo}`).join('\n')}`);
                            }
                          }}
                          tileContent={({ date }) => {
                            const eventos = selectedCliente.eventos?.filter(e => 
                              new Date(e.fecha).toDateString() === date.toDateString()
                            ) || [];
                            return eventos.length > 0 ? (
                              <div className="evento-marker">
                                <span className="evento-dot"></span>
                                {eventos.length > 1 && <span className="evento-count">{eventos.length}</span>}
                              </div>
                            ) : null;
                          }}
                        />
                      </div>
                      <div className="eventos-lista">
                        <h4>Próximos Eventos</h4>
                        {selectedCliente.eventos?.length > 0 ? (
                          selectedCliente.eventos
                            .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
                            .map(evento => (
                              <div key={evento.id} className="evento-item">
                                <div className="evento-icon">
                                  {evento.tipo === 'audiencia' && '⚖️'}
                                  {evento.tipo === 'reunion' && '🤝'}
                                  {evento.tipo === 'facturacion' && '💰'}
                                  {!['audiencia', 'reunion', 'facturacion'].includes(evento.tipo) && '📌'}
                                </div>
                                <div className="evento-info">
                                  <div className="evento-titulo">{evento.titulo}</div>
                                  <div className="evento-fecha">{evento.fecha}</div>
                                </div>
                              </div>
                            ))
                        ) : (
                          <p className="no-eventos">No hay eventos programados</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* ===== DOCUMENTOS ===== */}
              {activeTab === 'documentos' && (
                <div className="perfil-content">
                  <div className="perfil-section">
                    <div className="section-header-actions">
                      <h3><FiFolder className="section-icon" /> Documentos</h3>
                      <button className="btn-agregar-documento" onClick={() => setShowNuevoDocumento(true)}>
                        <FiPlus /> Agregar Documento
                      </button>
                    </div>
                    <div className="documentos-grid">
                      {selectedCliente.documentos?.map(doc => (
                        <div key={doc.id} className="documento-item">
                          <div className="doc-icon">{doc.tipo === 'identificacion' && '🆔'}{doc.tipo === 'contrato' && '📄'}{doc.tipo === 'formulario' && '📋'}{doc.tipo === 'evidencia' && '📎'}{doc.tipo === 'propuesta' && '📝'}</div>
                          <div className="doc-info">
                            <div className="doc-nombre">{doc.nombre}</div>
                            <div className="doc-fecha">{doc.fecha}</div>
                          </div>
                          <button className="doc-download" title="Abrir documento" onClick={() => doc.drive_file_id ? openDocumentPreview(doc) : (doc.web_view_link || doc.url ? window.open(doc.web_view_link || doc.url, '_blank', 'noopener,noreferrer') : alert('Este documento no tiene un archivo vinculado.'))}>
                            <FiDownload />
                          </button>
                        </div>
                      )) || <p className="no-documentos">No hay documentos</p>}
                    </div>
                    <div className="integración-drive">
                      <p><FiLink /> Integración con Google Drive pendiente (Backend)</p>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'documentos' && (
                <div className="perfil-content client-drive-real-panel"><div className="perfil-section">
                  <div className="client-drive-heading"><span>📁</span><div><b>Documentos reales de Google Drive</b><small>{selectedCliente.drive_folder_id ? 'Contenido leído directamente desde la carpeta vinculada del cliente.' : 'Este cliente aún no tiene una carpeta Drive vinculada.'}</small></div></div>
                  {selectedCliente.drive_folder_id && <div className="client-drive-create-folder"><input value={newDriveFolderName} onChange={(event) => setNewDriveFolderName(event.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); createDriveSubfolder(); } }} maxLength="180" placeholder="Nombre de nueva subcarpeta" /><button type="button" onClick={createDriveSubfolder} disabled={!newDriveFolderName.trim() || creatingDriveFolder}><FiFolderPlus /> {creatingDriveFolder ? 'Creando…' : 'Crear subcarpeta'}</button></div>}
                  {drivePath.length > 1 && <div className="drive-breadcrumb">{drivePath.map((item, index) => <React.Fragment key={item.id}><button onClick={() => openDrivePath(index)}>{item.name}</button>{index < drivePath.length - 1 && <span>/</span>}</React.Fragment>)}</div>}
                  {driveDocumentsError && <p className="client-drive-error">⚠️ {driveDocumentsError}</p>}
                  {!!driveDocuments.length && <div className="documentos-grid">{driveDocuments.map((doc) => doc.mime_type === 'application/vnd.google-apps.folder' ? <button className="documento-item drive-document" key={doc.id} onClick={() => openDriveFolder(doc)}><div className="doc-icon">📁</div><div className="doc-info"><div className="doc-nombre">{doc.name}</div><div className="doc-fecha">Abrir subcarpeta</div></div><FiFolder /></button> : <button className="documento-item drive-document" key={doc.id} onClick={() => openDocumentPreview(doc)}><div className="doc-icon">📄</div><div className="doc-info"><div className="doc-nombre">{doc.name}</div><div className="doc-fecha">{doc.modified_time || 'Google Drive'}</div></div><FiEye /></button>)}</div>}
                  {selectedCliente.drive_folder_id && !driveDocuments.length && !driveDocumentsError && <p className="no-documentos">La carpeta vinculada no contiene archivos visibles.</p>}
                </div></div>
              )}

              {activeTab === 'lista_documentos' && (
                <div className="perfil-content"><div className="perfil-section client-document-checklist"><div className="section-header-actions"><div><h3><FiCheckSquare className="section-icon" /> Lista de documentos</h3><p>Marque lo recibido y agregue requisitos específicos para este expediente.</p></div><span className="checklist-progress">{(selectedCliente.lista_documentos || []).filter(item => item.completado).length} / {(selectedCliente.lista_documentos || []).length} completos</span></div><div className="document-checklist-add"><input value={nuevoDocumentoLista} onChange={(event) => setNuevoDocumentoLista(event.target.value)} onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); handleAddDocumentCheck(); } }} placeholder="Ej. Pasaporte, certificado de nacimiento, taxes…" /><button onClick={handleAddDocumentCheck} disabled={!nuevoDocumentoLista.trim()}><FiPlus /> Agregar más</button></div><div className="document-checklist-items">{(selectedCliente.lista_documentos || []).length ? (selectedCliente.lista_documentos || []).map(item => <article key={item.id} className={item.completado ? 'completed' : ''}><button className="document-check-toggle" onClick={() => handleToggleDocumentCheck(item)} aria-label={item.completado ? `Marcar ${item.nombre} como pendiente` : `Marcar ${item.nombre} como completado`}>{item.completado ? <FiCheckCircle /> : <span />}</button><div><b>{item.nombre}</b><small>{item.completado ? `Completado${item.completado_por ? ` por ${item.completado_por}` : ''}` : 'Pendiente de recibir'}</small></div><button className="document-check-delete" onClick={() => handleDeleteDocumentCheck(item)} title="Quitar de la lista"><FiTrash2 /></button></article>) : <div className="document-check-empty"><span>📋</span><div><b>La lista está vacía</b><p>Agregue los documentos que necesita para este cliente.</p></div></div>}</div></div></div>
              )}

              {activeTab === 'ia' && <div className="perfil-content"><div className="perfil-section ai-summary-panel"><div className="section-header-actions"><div><p className="ai-kicker">GEMINI · EXPEDIENTE DEL CLIENTE</p><h3>🤖 Resumen inteligente</h3><p>Combina el CRM con extractos limitados de PDF y Word de la carpeta Google Drive vinculada.</p></div><button className="btn-agregar-documento" disabled={aiSummaryLoading} onClick={generateAiSummary}>{aiSummaryLoading ? 'Analizando expediente…' : '✨ Actualizar resumen'}</button></div>{aiSummaryError && <p className="client-drive-error">⚠️ {aiSummaryError}</p>}{aiSummary ? <><div className="ai-source-grid"><article><span>📋</span><b>CRM</b><small>Tareas, eventos, actividad y documentos</small></article><article><span>📁</span><b>Google Drive</b><small>{aiSummaryDrive?.connected ? `${aiSummaryDrive.items_count} elementos y ${aiSummaryDrive.excerpts_count || 0} PDF/Word` : aiSummaryDrive?.folder_linked ? 'Carpeta vinculada sin acceso actual' : 'Sin carpeta vinculada'}</small></article><article><span>🛡️</span><b>Privacidad</b><small>Extractos acotados; nunca se envían archivos completos</small></article></div><article className="ai-summary-result"><header><span>✨</span><div><b>Resumen generado con Gemini</b><small>Revisión profesional requerida antes de tomar decisiones.</small></div></header><div className="ai-summary-body">{aiSummary.split('\n').filter(Boolean).map((line, index) => <p key={index}>{line.replace(/^[-*]\s*/, '')}</p>)}</div>{aiSummaryDrive?.note && <footer>📁 {aiSummaryDrive.note}</footer>}</article></> : <div className="ai-summary-empty"><span>🤖</span><div><b>Resumen listo para generar</b><p>Analiza la actividad del CRM y extractos limitados de PDF y Word disponibles en Drive.</p></div></div>}</div></div>}

              {activeTab === 'ia' && aiSummaryDrive?.excerpts_count > 0 && (
                <div className="perfil-content ai-drive-evidence">
                  <div className="ai-evidence-card">
                    <div>
                      <span className="ai-evidence-icon">📑</span>
                      <div>
                        <b>Documentos considerados por Gemini</b>
                        <small>Se usaron extractos limitados de PDF y Word para complementar el resumen.</small>
                      </div>
                      <div className="info-item">
                        <label>Día de cobro mensual</label>
                        {isEditing ? (
                          <select value={editCliente.dia_cobro_mensual || ''} onChange={(e) => setEditCliente({...editCliente, dia_cobro_mensual: e.target.value ? Number(e.target.value) : null})}>
                            <option value="">Sin recordatorio programado</option>
                            {Array.from({length: 28}, (_, index) => index + 1).map((day) => <option key={day} value={day}>{day} de cada mes</option>)}
                          </select>
                        ) : (
                          <span>{selectedCliente.dia_cobro_mensual ? `${selectedCliente.dia_cobro_mensual} de cada mes` : 'No programado'}</span>
                        )}
                      </div>
                    </div>
                    <span className="ai-evidence-count">{aiSummaryDrive.excerpts_count} analizado{aiSummaryDrive.excerpts_count === 1 ? '' : 's'}</span>
                  </div>
                  <div className="ai-evidence-list">
                    {(aiSummaryDrive.analyzed_documents || []).map((name) => <span key={name}>📄 {name}</span>)}
                  </div>
                </div>
              )}

              {/* ===== TAREAS ===== */}
              {activeTab === 'tareas' && (
                <div className="perfil-content">
                  <div className="perfil-section">
                    <div className="section-header-actions">
                      <h3><FiCheckCircle className="section-icon" /> Tareas</h3>
                      <button className="btn-agregar-tarea" onClick={() => setShowNuevaTarea(true)}>
                        <FiPlus /> Nueva Tarea
                      </button>
                    </div>
                    <div className="tareas-list">
                      {selectedCliente.tareas?.map(tarea => (
                        <div key={tarea.id} className={`tarea-item ${tarea.completada ? 'completada' : ''}`}>
                          <input type="checkbox" checked={tarea.completada} onChange={() => handleToggleTarea(tarea.id)} />
                          <span className="tarea-titulo">{tarea.titulo}</span>
                          {tarea.descripcion && <span className="tarea-descripcion">{tarea.descripcion}</span>}
                          <span className="tarea-asignado"><FiUser size={12} /> {tarea.asignado_a || 'Sin asignar'}</span>
                          <span className="tarea-fecha">Vence: {tarea.fecha}</span>
                        </div>
                      )) || <p className="no-tareas">No hay tareas</p>}
                    </div>
                  </div>
                </div>
              )}

              {/* ===== COMUNICACIONES ===== */}
              {activeTab === 'comunicaciones' && (
                <div className="perfil-content">
                  <div className="perfil-section">
                    <div className="section-header-actions">
                      <h3><FiMessageCircle className="section-icon" /> Comunicaciones</h3>
                      <button className="btn-agregar-comunicacion" onClick={() => setShowNuevaComunicacion(true)}>
                        <FiPlus /> Registrar Comunicación
                      </button>
                    </div>
                    <div className="comunicaciones-list">
                      {selectedCliente.comunicaciones?.map(com => (
                        <div key={com.id} className="comunicacion-item">
                          <div className="com-tipo">{com.tipo === 'llamada' ? '📞' : com.tipo === 'email' ? '📧' : com.tipo === 'mensaje_texto' ? '📱' : '📨'} {com.tipo.toUpperCase()}</div>
                          <div className="com-detalle">
                            <div className="com-fecha">{com.fecha} - {com.hora}</div>
                            <div className="com-mensaje">{com.mensaje}</div>
                            <div className="com-realizada">Por: {com.realizada_por}</div>
                          </div>
                        </div>
                      )) || <p className="no-comunicaciones">No hay comunicaciones</p>}
                    </div>
                  </div>
                </div>
              )}

              {/* ===== FINANZAS ===== */}
              {activeTab === 'finanzas' && (
                <div className="perfil-content">
                  <div className="perfil-section">
                    <div className="section-header-actions">
                      <h3><FiDollarSign className="section-icon" /> Pagos</h3>
                      <div className="section-actions">
                        <button className="btn-editar-honorarios" onClick={handleEditarHonorarios}>
                          <FiEdit2 /> Editar Honorarios
                        </button>
                        <button className="btn-agregar-pago" onClick={() => setShowNuevoPago(true)}>
                          <FiPlus /> Registrar Pago
                        </button>
                      </div>
                    </div>
                    
                    {/* Resumen financiero */}
                    {(() => {
                      const totalPagado = selectedCliente.pagos?.reduce((sum, p) => sum + p.monto, 0) || 0;
                      const totalHonorarios = selectedCliente.honorarios_total || 0;
                      const balance = totalHonorarios - totalPagado;
                      return (
                        <div className="finanzas-header">
                          <div className="finanza-card">
                            <span className="label">Total Honorarios</span>
                            <span className="value">${totalHonorarios.toLocaleString('en-US')}</span>
                          </div>
                          <div className="finanza-card">
                            <span className="label">Total Pagado</span>
                            <span className="value">${totalPagado.toLocaleString('en-US')}</span>
                          </div>
                          <div className="finanza-card balance">
                            <span className="label">Balance</span>
                            <span className="value" style={{ color: balance > 0 ? '#e74c3c' : balance < 0 ? '#27ae60' : '#95a5a6' }}>
                              ${balance.toLocaleString('en-US')}
                            </span>
                            {balance > 0 && <span className="badge-pendiente">Pendiente</span>}
                            {balance === 0 && <span className="badge-pagado">Pagado</span>}
                            {balance < 0 && <span className="badge-sobrepago">Sobrepago</span>}
                          </div>
                          <div className="finanza-card">
                            <span className="label">Recordatorio mensual</span>
                            <select className="input-modern" value={selectedCliente.dia_cobro_mensual || ''} onChange={(event) => guardarDiaCobro(event.target.value)}>
                              <option value="">No programado</option>
                              {Array.from({length: 28}, (_, index) => index + 1).map((day) => <option key={day} value={day}>Día {day}</option>)}
                            </select>
                            <small>{balance > 0 ? 'Se enviará el día indicado o el lunes hábil siguiente.' : 'Sin saldo: no se enviarán recordatorios.'}</small>
                          </div>
                        </div>
                      );
                    })()}

                    <div className="pagos-list">
                      <h4>Historial de Pagos</h4>
                      {selectedCliente.pagos?.length > 0 ? (
                        selectedCliente.pagos.map(pago => (
                          <div key={pago.id} className="pago-item">
                            <div className="pago-info">
                              <span className="pago-fecha">{pago.fecha}</span>
                              <span className="pago-concepto">{pago.concepto}</span>
                              <span className="pago-metodo">{getMetodoPagoLabel(pago.metodo)}</span>
                            </div>
                            <div className="pago-actions">
                              <span className="pago-monto">${pago.monto.toLocaleString('en-US')}</span>
                              <button className="btn-pago-edit" onClick={() => handleEditarPago(pago)}>
                                <FiEdit2 size={14} />
                              </button>
                              <button className="btn-pago-delete" onClick={() => handleEliminarPago(pago.id)}>
                                <FiTrash2 size={14} />
                              </button>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="no-pagos">No hay pagos registrados</p>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* ===== HISTORIAL ===== */}
              {activeTab === 'historial' && (
                <div className="perfil-content">
                  <div className="perfil-section">
                    <h3><FiClock className="section-icon" /> Historial de Actividad</h3>
                    <div className="actividad-timeline">
                      {selectedCliente.actividad?.length ? selectedCliente.actividad.map(act => (
                        <div key={act.id} className="actividad-item">
                          <div className="actividad-dot"></div>
                          <div className="actividad-content">
                            <div className="actividad-accion">{act.accion}</div>
                            <div className="actividad-fecha">{act.fecha}</div>
                            <div className="actividad-usuario">Por: {act.usuario}</div>
                          </div>
                        </div>
                      )) : <p className="no-actividad">No hay actividad registrada</p>}
                    </div>
                  </div>
                </div>
              )}

            </div>
          </section>
        </div>
      )}

      {/* ============ MODALES ============ */}

      {showAgregarExpediente && (
        <div className="modal-overlay" onClick={() => setShowAgregarExpediente(false)}>
          <div className="modal-modern client-matter-modal" onClick={(event) => event.stopPropagation()}>
            <div className="modal-modern-header"><div><p>EXPEDIENTE ADICIONAL</p><h3>➕ Añadir otro caso</h3></div><button className="modal-close" onClick={() => setShowAgregarExpediente(false)}><FiX /></button></div>
            <div className="modal-modern-body"><p className="client-matter-copy">Este caso se asociará a <b>{selectedCliente?.nombre} {selectedCliente?.apellido}</b> y se creará en el Workspace correspondiente.</p><div className="form-group-modern"><label>Tipo de caso</label><select className="select-modern" value={nuevoTipoExpediente} onChange={(event) => setNuevoTipoExpediente(event.target.value)}>{tiposCaso.map((type) => <option key={type.valor} value={type.valor}>{type.label}</option>)}</select></div></div>
            <div className="modal-modern-footer"><button className="btn-cancel-modern" onClick={() => setShowAgregarExpediente(false)}>Cancelar</button><button className="btn-save-modern" onClick={handleAgregarExpediente}><FiPlus /> Crear expediente</button></div>
          </div>
        </div>
      )}

      {/* Modal Agregar Caso */}
      {showAgregarCaso && (
        <div className="modal-overlay" onClick={() => setShowAgregarCaso(false)}>
          <div className="modal-content-wrapper" onClick={(e) => e.stopPropagation()}>
            <AgregarCaso personalInjury={personalInjury} onCreated={onCaseCreated} onClose={() => {
              setShowAgregarCaso(false);
              cargarClientes();
            }} />
          </div>
        </div>
      )}

      {/* Modal Nueva Tarea */}
      {showNuevaTarea && (
        <div className="modal-overlay" onClick={() => setShowNuevaTarea(false)}>
          <div className="modal-modern" onClick={(e) => e.stopPropagation()}>
            <div className="modal-modern-header">
              <h3>📝 Nueva Tarea</h3>
              <button className="modal-close" onClick={() => setShowNuevaTarea(false)}><FiX /></button>
            </div>
            <div className="modal-modern-body">
              <div className="form-modern">
                <div className="form-group-modern">
                  <label>Título de la tarea *</label>
                  <input type="text" value={nuevaTarea.titulo} onChange={(e) => setNuevaTarea({...nuevaTarea, titulo: e.target.value})} placeholder="Ej: Llamada de seguimiento" className="input-modern" />
                </div>
                <div className="form-group-modern">
                  <label>Descripción</label>
                  <textarea value={nuevaTarea.descripcion} onChange={(e) => setNuevaTarea({...nuevaTarea, descripcion: e.target.value})} placeholder="Detalle de la tarea" className="input-modern" rows="3" />
                </div>
                <div className="form-group-modern">
                  <label>Asignar a *</label>
                  <select value={nuevaTarea.asignado_a} onChange={(e) => setNuevaTarea({...nuevaTarea, asignado_a: e.target.value})} className="select-modern">
                    <option value="">Seleccionar usuario...</option>
                    {usuarios.map(u => (
                      <option key={u.id} value={u.nombre}>{u.nombre} - {u.rol}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group-modern">
                  <label>Fecha de vencimiento</label>
                  <input type="date" value={nuevaTarea.fecha} onChange={(e) => setNuevaTarea({...nuevaTarea, fecha: e.target.value})} className="input-modern" />
                </div>
              </div>
            </div>
            <div className="modal-modern-footer">
              <button className="btn-cancel-modern" onClick={() => setShowNuevaTarea(false)}>Cancelar</button>
              <button className="btn-save-modern" onClick={handleAgregarTarea} disabled={taskSaving}>
                <FiSave /> {taskSaving ? 'Guardando…' : 'Guardar tarea'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Nueva Comunicación */}
      {showNuevaComunicacion && (
        <div className="modal-overlay" onClick={() => setShowNuevaComunicacion(false)}>
          <div className="modal-modern" onClick={(e) => e.stopPropagation()}>
            <div className="modal-modern-header">
              <h3>💬 Registrar Comunicación</h3>
              <button className="modal-close" onClick={() => setShowNuevaComunicacion(false)}><FiX /></button>
            </div>
            <div className="modal-modern-body">
              <div className="form-modern">
                <div className="form-group-modern">
                  <label>Tipo *</label>
                  <select value={nuevaComunicacion.tipo} onChange={(e) => setNuevaComunicacion({...nuevaComunicacion, tipo: e.target.value})} className="select-modern">
                    {tiposComunicacion.map(t => <option key={t} value={t}>{t.charAt(0).toUpperCase() + t.slice(1)}</option>)}
                  </select>
                </div>
                <div className="form-group-modern">
                  <label>Realizada por *</label>
                  <select value={nuevaComunicacion.realizada_por} onChange={(e) => setNuevaComunicacion({...nuevaComunicacion, realizada_por: e.target.value})} className="select-modern">
                    <option value="">Seleccionar usuario...</option>
                    {usuarios.map(u => (
                      <option key={u.id} value={u.nombre}>{u.nombre} - {u.rol}</option>
                    ))}
                  </select>
                </div>
                <div className="form-row-modern">
                  <div className="form-group-modern">
                    <label>Fecha</label>
                    <input type="date" value={nuevaComunicacion.fecha} onChange={(e) => setNuevaComunicacion({...nuevaComunicacion, fecha: e.target.value})} className="input-modern" />
                  </div>
                  <div className="form-group-modern">
                    <label>Hora</label>
                    <input type="time" value={nuevaComunicacion.hora} onChange={(e) => setNuevaComunicacion({...nuevaComunicacion, hora: e.target.value})} className="input-modern" />
                  </div>
                </div>
                <div className="form-group-modern">
                  <label>Mensaje/Notas *</label>
                  <textarea value={nuevaComunicacion.mensaje} onChange={(e) => setNuevaComunicacion({...nuevaComunicacion, mensaje: e.target.value})} placeholder="Detalles de la comunicación..." rows="3" className="input-modern" />
                </div>
              </div>
            </div>
            <div className="modal-modern-footer">
              <button className="btn-cancel-modern" onClick={() => setShowNuevaComunicacion(false)}>Cancelar</button>
              <button className="btn-save-modern" onClick={handleAgregarComunicacion}><FiSave /> Guardar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Nuevo Pago */}
      {showNuevoPago && (
        <div className="modal-overlay" onClick={() => setShowNuevoPago(false)}>
          <div className="modal-modern" onClick={(e) => e.stopPropagation()}>
            <div className="modal-modern-header">
              <h3>💰 Registrar Pago</h3>
              <button className="modal-close" onClick={() => setShowNuevoPago(false)}><FiX /></button>
            </div>
            <div className="modal-modern-body">
              <div className="form-modern">
                <div className="form-group-modern">
                  <label>Monto *</label>
                  <div className="input-with-icon">
                    <span className="input-icon">$</span>
                    <input type="number" value={nuevoPago.monto} onChange={(e) => setNuevoPago({...nuevoPago, monto: e.target.value})} placeholder="0.00" min="0" step="0.01" className="input-modern" />
                  </div>
                </div>
                <div className="form-group-modern">
                  <label>Concepto</label>
                  <input type="text" value={nuevoPago.concepto} onChange={(e) => setNuevoPago({...nuevoPago, concepto: e.target.value})} placeholder="Ej: Retainer inicial" className="input-modern" />
                </div>
                <div className="form-row-modern">
                  <div className="form-group-modern">
                    <label>Fecha</label>
                    <input type="date" value={nuevoPago.fecha} onChange={(e) => setNuevoPago({...nuevoPago, fecha: e.target.value})} className="input-modern" />
                  </div>
                  <div className="form-group-modern">
                    <label>Método de pago</label>
                    <select value={nuevoPago.metodo} onChange={(e) => setNuevoPago({...nuevoPago, metodo: e.target.value})} className="select-modern">
                      <option value="zelle">💳 Zelle</option>
                      <option value="tarjeta_credito">💳 Tarjeta Crédito</option>
                      <option value="efectivo">💵 Efectivo</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-modern-footer">
              <button className="btn-cancel-modern" onClick={() => setShowNuevoPago(false)}>Cancelar</button>
              <button className="btn-save-modern" onClick={handleAgregarPago}><FiSave /> Registrar Pago</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar Pago */}
      {showEditarPago && editandoPago && (
        <div className="modal-overlay" onClick={() => setShowEditarPago(false)}>
          <div className="modal-modern" onClick={(e) => e.stopPropagation()}>
            <div className="modal-modern-header">
              <h3>✏️ Editar Pago</h3>
              <button className="modal-close" onClick={() => setShowEditarPago(false)}><FiX /></button>
            </div>
            <div className="modal-modern-body">
              <div className="form-modern">
                <div className="form-group-modern">
                  <label>Monto *</label>
                  <div className="input-with-icon">
                    <span className="input-icon">$</span>
                    <input type="number" value={editandoPago.monto} onChange={(e) => setEditandoPago({...editandoPago, monto: parseFloat(e.target.value) || 0})} min="0" step="0.01" className="input-modern" />
                  </div>
                </div>
                <div className="form-group-modern">
                  <label>Concepto</label>
                  <input type="text" value={editandoPago.concepto} onChange={(e) => setEditandoPago({...editandoPago, concepto: e.target.value})} placeholder="Ej: Retainer inicial" className="input-modern" />
                </div>
                <div className="form-row-modern">
                  <div className="form-group-modern">
                    <label>Fecha</label>
                    <input type="date" value={editandoPago.fecha} onChange={(e) => setEditandoPago({...editandoPago, fecha: e.target.value})} className="input-modern" />
                  </div>
                  <div className="form-group-modern">
                    <label>Método de pago</label>
                    <select value={editandoPago.metodo} onChange={(e) => setEditandoPago({...editandoPago, metodo: e.target.value})} className="select-modern">
                      <option value="zelle">💳 Zelle</option>
                      <option value="tarjeta_credito">💳 Tarjeta Crédito</option>
                      <option value="efectivo">💵 Efectivo</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-modern-footer">
              <button className="btn-cancel-modern" onClick={() => setShowEditarPago(false)}>Cancelar</button>
              <button className="btn-save-modern" onClick={handleGuardarEdicionPago}><FiSave /> Guardar Cambios</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Editar Honorarios */}
      {showEditarHonorarios && (
        <div className="modal-overlay" onClick={() => setShowEditarHonorarios(false)}>
          <div className="modal-modern" onClick={(e) => e.stopPropagation()}>
            <div className="modal-modern-header">
              <h3>💰 Editar Honorarios Totales</h3>
              <button className="modal-close" onClick={() => setShowEditarHonorarios(false)}><FiX /></button>
            </div>
            <div className="modal-modern-body">
              <div className="form-modern">
                <div className="form-group-modern">
                  <label>Honorarios Totales</label>
                  <div className="input-with-icon">
                    <span className="input-icon">$</span>
                    <input type="number" value={editarHonorarios.honorarios_total} onChange={(e) => setEditarHonorarios({...editarHonorarios, honorarios_total: parseFloat(e.target.value) || 0})} min="0" step="0.01" className="input-modern" />
                  </div>
                  <small className="help-text">Este es el monto total acordado con el cliente</small>
                </div>
                <div className="form-group-modern">
                  <div className="info-box">
                    <FiInfo /> Pagos registrados: ${selectedCliente?.pagos?.reduce((s, p) => s + p.monto, 0).toLocaleString('en-US') || 0}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-modern-footer">
              <button className="btn-cancel-modern" onClick={() => setShowEditarHonorarios(false)}>Cancelar</button>
              <button className="btn-save-modern" onClick={handleGuardarHonorarios}><FiSave /> Guardar Honorarios</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Nuevo Documento */}
      {showNuevoDocumento && (
        <div className="modal-overlay" onClick={() => setShowNuevoDocumento(false)}>
          <div className="modal-modern" onClick={(e) => e.stopPropagation()}>
            <div className="modal-modern-header">
              <h3>📄 Agregar Documento</h3>
              <button className="modal-close" onClick={() => setShowNuevoDocumento(false)}><FiX /></button>
            </div>
            <div className="modal-modern-body">
              <div className="form-modern">
                <div className="form-group-modern">
                  <label>Nombre del documento *</label>
                  <input type="text" value={nuevoDocumento.nombre} onChange={(e) => setNuevoDocumento({...nuevoDocumento, nombre: e.target.value})} placeholder="Ej: Contrato_firmado.pdf" className="input-modern" />
                </div>
                <div className="form-group-modern">
                  <label>Tipo</label>
                  <select value={nuevoDocumento.tipo} onChange={(e) => setNuevoDocumento({...nuevoDocumento, tipo: e.target.value})} className="select-modern">
                    {tiposDocumento.map(t => <option key={t} value={t}>{t.charAt(0).toUpperCase() + t.slice(1)}</option>)}
                  </select>
                </div>
                <div className="form-group-modern">
                  <label>Fecha</label>
                  <input type="date" value={nuevoDocumento.fecha} onChange={(e) => setNuevoDocumento({...nuevoDocumento, fecha: e.target.value})} className="input-modern" />
                </div>
                <div className="form-group-modern">
                  <label>Archivo (PDF, Word, imagen u otro)</label>
                  <input type="file" accept=".pdf,.doc,.docx,image/*" onChange={(e) => setDocumentFile(e.target.files?.[0] || null)} className="input-modern" />
                  <small className="help-text">Se guardará en la carpeta Google Drive vinculada a este cliente.</small>
                </div>
                <div className="form-group-modern integration-note">
                  <div className="note-box">
                    <FiLink /> <span>📌 Pendiente: Integración con Google Drive para subir archivos</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-modern-footer">
              <button className="btn-cancel-modern" onClick={() => setShowNuevoDocumento(false)}>Cancelar</button>
              <button className="btn-save-modern" onClick={handleUploadDocumento}><FiUpload /> Subir a Google Drive</button>
            </div>
          </div>
        </div>
      )}

      {previewDocument && <div className="document-preview-overlay" onClick={closeDocumentPreview}><section className="document-preview-modal" onClick={(event) => event.stopPropagation()}><header><div><p>VISTA PREVIA · EXPEDIENTE</p><h3>{previewDocument.name || previewDocument.nombre}</h3></div><button onClick={closeDocumentPreview}><FiX /></button></header>{previewDocumentLoading ? <div className="document-preview-state">Cargando documento seguro…</div> : previewDocumentUrl && (previewDocument.mime_type === 'application/pdf' || String(previewDocument.name || '').toLowerCase().endsWith('.pdf')) ? <iframe title={previewDocument.name} src={previewDocumentUrl} /> : previewDocumentUrl && String(previewDocument.mime_type || '').startsWith('image/') ? <div className="document-preview-image"><img src={previewDocumentUrl} alt={previewDocument.name} /></div> : <div className="document-preview-state">Este formato no se puede renderizar directamente. Puede descargarlo de forma segura.</div>}<footer>{previewDocumentUrl && <a href={previewDocumentUrl} download={previewDocument.name || previewDocument.nombre}>⬇ Descargar archivo</a>}{previewDocument.web_view_link && <a href={previewDocument.web_view_link} target="_blank" rel="noreferrer">Abrir en Google Drive ↗</a>}</footer></section></div>}

      {/* Modal Nuevo Evento */}
      {showNuevoEvento && (
        <div className="modal-overlay" onClick={() => setShowNuevoEvento(false)}>
          <div className="modal-modern" onClick={(e) => e.stopPropagation()}>
            <div className="modal-modern-header">
              <h3>📅 Nuevo Evento</h3>
              <button className="modal-close" onClick={() => setShowNuevoEvento(false)}><FiX /></button>
            </div>
            <div className="modal-modern-body">
              <div className="form-modern">
                <div className="form-group-modern">
                  <label>Título del evento *</label>
                  <input type="text" value={nuevoEvento.titulo} onChange={(e) => setNuevoEvento({...nuevoEvento, titulo: e.target.value})} placeholder="Ej: Audiencia en Corte" className="input-modern" />
                </div>
                <div className="form-row-modern">
                  <div className="form-group-modern">
                    <label>Fecha</label>
                    <input type="date" value={nuevoEvento.fecha} onChange={(e) => setNuevoEvento({...nuevoEvento, fecha: e.target.value})} className="input-modern" />
                  </div>
                  <div className="form-group-modern">
                    <label>Tipo</label>
                    <select value={nuevoEvento.tipo} onChange={(e) => setNuevoEvento({...nuevoEvento, tipo: e.target.value})} className="select-modern">
                      {tiposEvento.map(t => (
                        <option key={t} value={t}>
                          {t === 'audiencia' && '⚖️'} {t === 'reunion' && '🤝'} {t === 'facturacion' && '💰'} {t === 'otro' && '📌'}
                          {t.charAt(0).toUpperCase() + t.slice(1)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-modern-footer">
              <button className="btn-cancel-modern" onClick={() => setShowNuevoEvento(false)}>Cancelar</button>
              <button className="btn-save-modern" onClick={handleAgregarEvento}><FiSave /> Agregar Evento</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Clientes;
